import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Overlay, Popover, Table } from "react-bootstrap";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import { commonService } from "../../../../utils/commonService";
import { compName, month } from "../../../../utils/constant";
import Loader from "../../../Loader/Loader";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import { errorToastMessage } from "../../../../utils/toastMessage";
import AnnualSummaryChatModal from "./AnnualSummaryChatModal";
import chatIcon from "../../../../Assets/Images/Revenue-management/chat.svg";
import moment from "moment";
import DatePicker from "react-datepicker";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import WidgetNote from "../../WidgetNote";


const AnnualSummaryDrilldown = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const userDetail = commonService.getLoginUserData();
    const widgetDetailRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const yearsArr = [
        ...commonService.getPastYearForDropDown(10),
        ...commonService.getFutureYearForDropDown(10),
        new Date().getFullYear(),
    ]?.sort(function (a, b) {
        return a - b;
    });
    const OTBTableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
    ];
    const netStlyTableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
    ];
    const totalLyTableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
    ];
    const budgetTableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
    ];
    const emaForecastTableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0, var: 0 },
    ];
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [expandedMonth, setExpandedMonth] = useState(null);
    const [expandedDailyData, setExpandedDailyData] = useState({});
    const [dailyLoading, setDailyLoading] = useState({
        otb: false,
        stly: false,
        budget: false,
        forecast: false,
    });


    const fetchDailyDataForMonth = (monthName) => {
        if (api !== 0) {
            if (!monthName) return;
            const monthNum = moment().month(monthName).format("M");
            const daysInMonth = moment(`${selectedYear}-${monthNum}`, "YYYY-M").daysInMonth();
            const startDay = new Date(selectedYear, monthNum - 1, 1);
            const endDay = new Date(selectedYear, monthNum - 1, daysInMonth);

            setDailyLoading({
                otb: true,
                stly: true,
                budget: true,
                forecast: true,
            });

            // 1. OTB Daily API
            apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
                    body: {
                        AsOfDate: para?.asOfDate,
                        startDate: commonService.getDateInDBFormat(startDay),
                        endDate: commonService.getDateInDBFormat(endDay),
                        propertyCode: para?.propertyCode,
                    },
                },
                false
            )
                .then((res) => {
                    let rawOtb = apiResponse(false, res)?.data?.data || [];
                    let mappedOtb = rawOtb.map((d) => ({
                        ...d,
                        date: d.Date || d.date,
                        occ: d.TotalOCCPercentage || d.occ || 0,
                        rms: d.OnTheBook || d.rms || 0,
                        adr: d.ADR || d.adr || 0,
                        rev: d.REV || d.rev || 0,
                    }));
                    setExpandedDailyData((prev) => ({
                        ...prev,
                        [monthName]: {
                            ...(prev[monthName] || {}),
                            otb: mappedOtb,
                        },
                    }));
                })
                .catch((err) => console.error("fetchDailyDataForMonth OTB error:", err))
                .finally(() => {
                    setDailyLoading((prev) => ({ ...prev, otb: false }));
                });

            // 2. STLY / LY Daily API
            apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
                    body: {
                        AsOfDate: para?.asOfDate,
                        startDate: commonService.getDateInDBFormat(startDay),
                        endDate: commonService.getDateInDBFormat(endDay),
                        propertyCode: para?.propertyCode,
                    },
                },
                false
            )
                .then((res) => {
                    let rawStly = apiResponse(false, res)?.data?.data || [];
                    let mappedStly = rawStly.map((d) => ({
                        ...d,
                        date: d.dates || d.date,
                        occ: parseInt(d.stlyocc || d.stlyoccper || 0),
                        rms: d.stlyotb || 0,
                        adr: d.stlyadr || 0,
                        rev: d.stlyrevenue || 0,
                    }));
                    let mappedLy = rawStly.map((d) => ({
                        ...d,
                        date: d.dates || d.date,
                        occ: parseInt(d.lyocc || d.lyoccper || 0),
                        rms: d.lyotb || 0,
                        adr: d.lyadr || 0,
                        rev: d.lyrevenue || 0,
                    }));
                    setExpandedDailyData((prev) => ({
                        ...prev,
                        [monthName]: {
                            ...(prev[monthName] || {}),
                            stly: mappedStly,
                            ly: mappedLy,
                        },
                    }));
                })
                .catch((err) => console.error("fetchDailyDataForMonth STLY error:", err))
                .finally(() => {
                    setDailyLoading((prev) => ({ ...prev, stly: false }));
                });

            // 3. Budget Daily API
            apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.LAST_YEAR_AND_FORECAST.GET_BUDGET_DATA,
                    body: {
                        asOfDate: para?.asOfDate,
                        propertyCode: para?.propertyCode,
                        propertyid: para?.propertyDetail?.propertyid,
                        startDate: commonService.getDateInDBFormat(startDay),
                        endDate: commonService.getDateInDBFormat(endDay),
                    },
                },
                false
            )
                .then((res) => {
                    let rawBudget = apiResponse(false, res)?.data?.data || [];
                    let mappedBudget = rawBudget.map((d) => ({
                        ...d,
                        date: d.budgetdate || d.date,
                        occ: parseInt(d.OCC || d.occ || d.OCCPER || 0),
                        rms: d.RMS || d.rms || 0,
                        adr: d.ADR || d.adr || 0,
                        rev: d.REV || d.rev || 0,
                    }));
                    setExpandedDailyData((prev) => ({
                        ...prev,
                        [monthName]: {
                            ...(prev[monthName] || {}),
                            budget: mappedBudget,
                        },
                    }));
                })
                .catch((err) => console.error("fetchDailyDataForMonth Budget error:", err))
                .finally(() => {
                    setDailyLoading((prev) => ({ ...prev, budget: false }));
                });

            // 4. Forecast Daily API
            apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                    body: {
                        AsOfDate: para?.asOfDate,
                        startDate: commonService.getDateInDBFormat(startDay),
                        endDate: commonService.getDateInDBFormat(endDay),
                        propertyCode: para?.propertyCode,
                        propertyid: para?.propertyDetail?.propertyid,
                        ForcastType: (selectedForecast ? selectedForecast : "ema").toLowerCase(),
                    },
                },
                false
            )
                .then((res) => {
                    let rawForecast = apiResponse(false, res)?.data?.data || [];
                    let mappedForecast = rawForecast.map((d) => ({
                        ...d,
                        date: d.Date || d.Dates || d.date,
                        occ: parseInt(d.OCC || d.occ || d.OccPerc || 0),
                        rms: d.RMS || d.rms || 0,
                        adr: d["Optimal Bar"] || d.R28AVG || d.adr || d.ADR || 0,
                        rev:
                            parseFloat(d.RMS || d.rms || 0) *
                            parseFloat(d["Optimal Bar"] || d.R28AVG || d.adr || 0) ||
                            d.rev || d.REV ||
                            0,
                    }));
                    setExpandedDailyData((prev) => ({
                        ...prev,
                        [monthName]: {
                            ...(prev[monthName] || {}),
                            forecast: mappedForecast,
                        },
                    }));
                })
                .catch((err) => console.error("fetchDailyDataForMonth Forecast error:", err))
                .finally(() => {
                    setDailyLoading((prev) => ({ ...prev, forecast: false }));
                });
        }
    };

    const toggleMonth = (monthName) => {
        if (expandedMonth === monthName) {
            setExpandedMonth(null);
        } else {
            setExpandedMonth(monthName);
            if (!expandedDailyData[monthName]) {
                fetchDailyDataForMonth(monthName);
            }
        }
    };

    const getDaysInMonth = (monthStr, year) => {
        const monthNum = moment().month(monthStr).format("M");
        const daysInMonth = moment(`${year}-${monthNum}`, "YYYY-M").daysInMonth();
        let days = [];
        for (let i = 1; i <= daysInMonth; i++) {
            days.push(moment(`${year}-${monthNum}-${i}`, "YYYY-M-D").format("YYYY-MM-DD"));
        }
        return days;
    };

    const getMonthEvents = (monthStr) => {
        const events = eventListRef.current || eventListState || [];
        if (!events || events.length === 0) return [];
        const monthIndex = month.indexOf(monthStr);
        if (monthIndex === -1) return [];
        const startOfMonth = moment(new Date(selectedYear, monthIndex, 1)).startOf("day");
        const endOfMonth = moment(new Date(selectedYear, monthIndex + 1, 0)).endOf("day");
        return events.filter((x) => {
            if (!x?.startDate) return false;
            let startingDate = moment(x?.startDate);
            let endingDate = x?.endDate ? moment(x?.endDate) : startingDate;
            return (
                startingDate.isSameOrBefore(endOfMonth, "day") &&
                endingDate.isSameOrAfter(startOfMonth, "day")
            );
        });
    };
    const calculateDailyVariance = (baseVal, targetVal) => {
        let b = parseFloat(baseVal) || 0;
        let t = parseFloat(targetVal) || 0;
        if (b > 0 && t > 0) {
            let v = ((b * 100) / t) - 100;
            return isFinite(v) && !isNaN(v) ? v : 0;
        }
        return 0;
    };
    const [OTBData, setOTBData] = useState(null);
    const [netStlyData, setNetStlyData] = useState(null);
    const [sevenPickupFromData, setSevenPickupFromData] = useState(null);
    const [pickupLoading, setPickupLoading] = useState(false);
    const [pickupDate, setPickupDate] = useState(() => {
        let d = new Date(para?.asOfDate || new Date());
        d.setDate(d.getDate() - 1);
        return d;
    });

    useEffect(() => {
        if (para?.asOfDate) {
            let d = new Date(para?.asOfDate);
            d.setDate(d.getDate() - 1);
            setPickupDate(d);
        }
    }, [para?.asOfDate]);

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        Target: null,
        Position: "bottom",
    });
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef(-1);
    const hoverRowRef = useRef(null);
    const sevenMaxDateRef = useRef();
    if (para?.asOfDate && !sevenMaxDateRef.current) {
        let sDate = new Date(para?.asOfDate);
        sevenMaxDateRef.current = sDate.setDate(sDate.getDate() - 1);
    }
    const selectSevenPickupDate = pickupDate ? moment(pickupDate).format("YYYY-MM-DD") : undefined;
    const selectAsOfDate = para?.asOfDate;

    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const [totalLyData, setTotalLyData] = useState(null);
    const [budgetData, setBudgetData] = useState(null);
    const [emaForecastData, setEmaForecastData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { propertyCode, snapshotId } = useParams();

    const [otbLoading, setOtbLoading] = useState(true);
    const [budgetLoading, setBudgetLoading] = useState(true);
    const [netStlyLoading, setNetStlyLoading] = useState(true);
    const [totalLyLoading, setTotalLyLoading] = useState(true);
    const [emaForecastLoading, setEmaForecastLoading] = useState(true);
    const [novaForecastLoading, setNovaForecastLoading] = useState(true);
    const [aiComment] = useState(null);
    const [selectedForecast, setSelectedForecast] = useState(propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema");
    const [showVariance, setShowVariance] = useState(false);
    const [varianceData, setVarianceData] = useState(null);
    const [selectedBudgetVariance, setSelectedBudgetVariance] = useState("");
    const [budgetVarianceData, setBudgetVarianceData] = useState(null);
    const [selectedForecastVariance, setSelectedForecastVariance] = useState("");
    const [forecastVarianceData, setForecastVarianceData] = useState(null);
    const [showChatModal, setShowChatModal] = useState(false);
    const chatApiPayloadRef = useRef();
    const commentPayloadRef = useRef({});
    const aiGenerateCommentApiCalledRef = useRef(false);
    const [selectedSTLY, setSelectedSTLY] = useState("netStly");

    const closeChatModal = () => {
        setShowChatModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    let otbocc = 0,
        otbrms = 0,
        otbadr = 0,
        otbrev = 0,
        netStlyOcc = 0,
        netStlyRms = 0,
        netStlyAdr = 0,
        netStlyRev = 0,
        totalLyOcc = 0,
        totalLyRms = 0,
        totalLyAdr = 0,
        totalLyRev = 0,
        budgetOcc = 0,
        budgetRms = 0,
        budgetAdr = 0,
        budgetRev = 0,
        emaForecastOcc = 0,
        emaForecastRms = 0,
        emaForecastAdr = 0,
        emaForecastRev = 0,
        sevenPickupRms = 0,
        sevenPickupRev = 0,
        varianceNetStlyRms = 0,
        varianceTotalLyRms = 0,
        varianceBudgetRms = 0,
        varianceForecastRms = 0,
        budgetVarianceOtbRms = 0;

    const eventListRef = useRef();
    const [eventListState, setEventListState] = useState([]);
    const eventListPropsRef = useRef();
    const selectedEventDateRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const [noteDetail, setNoteDetail] = useState(null);
    const clickedDateForNote = useRef();
    const [showDailyNoteSidebar, setShowDailyNoteSidebar] = useState(false);
    const closeDailyNoteSideBar = () => {
        setShowDailyNoteSidebar(false);
        getNoteByDataList();
    };

    const getNoteByDataList = async () => {
        if (api !== 0) {
            let propId = propertyDetailFromRTK?.propertyid ? parseInt(propertyDetailFromRTK?.propertyid) : (para?.propertyDetail?.propertyid ? parseInt(para?.propertyDetail?.propertyid) : 0);
            if (!propId) return;
            let noteByDataListResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.Configuration +
                        API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                    body: {
                        propertyid: propId,
                        widgetid: 0,
                        startdate: `${selectedYear}-01-01`,
                        enddate: `${selectedYear}-12-31`,
                    },
                },
                false
            );

            let response = apiResponse(false, noteByDataListResponse);

            if (response?.isValidate) {
                setNoteDetail(response?.data?.data);
            } else {
                setNoteDetail(null);
            }
        }
    };

    const getEventList = async () => {
        if (api !== 0) {
            let propId = propertyDetailFromRTK?.propertyid ? parseInt(propertyDetailFromRTK?.propertyid) : (para?.propertyDetail?.propertyid ? parseInt(para?.propertyDetail?.propertyid) : 0);
            if (!propId) return;
            let eventList = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                    body: {
                        pageNum: 1,
                        pageSize: 10,
                        sortColumn: "",
                        sortDirection: "asc",
                        searchValue: "",
                        propertyid: propId,
                        startdate: null,
                        enddate: null,
                        eventname: "",
                        eventtypeterm: "",
                        yearterm: ``,
                    },
                },
                false
            );

            let eventListResponse = apiResponse(false, eventList);

            if (eventListResponse?.isValidate) {
                let eventListArr = [];

                eventListResponse?.data?.data?.forEach((item) => {
                    try {
                        let singleEventObj = {
                            id: item?.eventid ? item?.eventid : 0,
                            name: item?.eventname,
                            detail: item?.eventdetails,
                            startDate: item?.startdate,
                            endDate: item?.enddate,
                            eventJson: item?.eventjson,
                            eventResourceId: item?.eventsourceid,
                        };
                        let eventJsonData = "";
                        if (item?.eventjson) {
                            var decodedString = decodeURIComponent(item?.eventjson);
                            const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                            const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                            eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                            let desc = eventJsonData?.description?.replaceAll("+", " ");
                            singleEventObj = {
                                ...singleEventObj,
                                labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                                rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                                local_rank: eventJsonData?.local_rank
                                    ? eventJsonData?.local_rank
                                    : 0,
                                phq_attendance: eventJsonData?.phq_attendance
                                    ? eventJsonData?.phq_attendance
                                    : 0,
                                geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                                geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                                detail: desc,
                            };
                        }
                        eventListArr.push(singleEventObj);
                    } catch (err) { }
                });
                eventListRef.current = eventListArr;
                setEventListState(eventListArr);
            }

            if (!eventListResponse?.isValidate) {
                eventListRef.current = [];
                setEventListState([]);
            }
        }
    };

    useEffect(() => {
        if (propertyDetailFromRTK?.propertyid || para?.propertyDetail?.propertyid) {
            getEventList();
            getNoteByDataList();
        }
    }, [propertyDetailFromRTK?.propertyid, para?.propertyDetail?.propertyid, selectedYear]);

    const getFLAG_MECHANISM = async (startDate, endDate) => {
        let List = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: {
                    asofdate: para?.asOfDate,
                    startdate: commonService.getDateInDBFormat(startDate),
                    enddate: commonService.getDateInDBFormat(endDate),
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let Response = apiResponse(false, List);

        if (Response?.isValidate) {
        }

        if (!Response?.isValidate) {
        }
    };

    const getORGDetail = async () => {
        setOtbLoading(true);
        let onTheBookResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.ANNUAL_SUMMARY.ON_THE_BOOK,
                body: { AsOfDate: para?.asOfDate, year: selectedYear, propertyCode: para?.propertyCode },
            }, false
        );
        let response = apiResponse(false, onTheBookResponse);
        if (response?.isValidate) { setOTBData(response?.data?.data); }
        else { setOTBData([]); }
        setOtbLoading(false);
    };

    const getSevenPickupFromData = async (year, selectedPickupDate) => {
        setPickupLoading(true);
        let pickupDateToUse = selectedPickupDate !== undefined ? selectedPickupDate : pickupDate;
        if (!pickupDateToUse) {
            pickupDateToUse = new Date(para?.asOfDate);
            pickupDateToUse.setDate(pickupDateToUse.getDate() - 1);
        }
        let pickupDate = pickupDateToUse;

        let startOfYear = new Date(year, 0, 1);
        let endOfYear = new Date(year, 11, 31);

        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: commonService.getDateInDBFormat(startOfYear),
                    endDate: commonService.getDateInDBFormat(endOfYear),
                    pickupDate: moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: para?.propertyCode,
                    ForcastType: (selectedForecast ? selectedForecast : "ema").toLowerCase(),
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let arr = response?.data?.data?.data || [];
            let mapped = arr.map((item, index) => {
                let rawDate = item.Date || item.Dates || item.date || item.stay_date || item.staydate || item.StayDate;
                if (rawDate && moment(rawDate).isValid()) {
                    let formatted = moment(rawDate).format("YYYY-MM-DD");
                    item.date = formatted;
                    item.Date = formatted;
                } else {
                    let dateForTd = new Date(year, 0, 1);
                    let formatted = commonService.getDateInDBFormat(
                        new Date(dateForTd.setDate(dateForTd.getDate() + index))
                    );
                    item.date = formatted;
                    item.Date = formatted;
                }
                return item;
            });
            setSevenPickupFromData(mapped);
        } else {
            setSevenPickupFromData([]);
        }
        setPickupLoading(false);
    };

    const getNetStlyDetail = async (keyType) => {
        setNetStlyLoading(true);
        let urlEndpoint = keyType === "netStly" ? API_URL.ANNUAL_SUMMARY.NET_STLY_DATEWISE : API_URL.ANNUAL_SUMMARY.NET_TOTAL_STLY_DATEWISE;
        let netStlyDetailResponse = await apiCall({
            method: "POST",
            url: `${API_URL.BASE_API_URL.SnapShot}${urlEndpoint}`,
            body: { asofdate: para?.asOfDate, year: selectedYear, propertycode: para?.propertyCode }
        }, false);
        let response = apiResponse(false, netStlyDetailResponse);
        if (response?.isValidate) { setNetStlyData(response?.data?.data); } else { setNetStlyData([]); }
        setNetStlyLoading(false);
    };

    const getTotalLyDetail = async () => {
        setTotalLyLoading(true);
        let totalLyDetailResponse = await apiCall({
            method: "POST",
            url: API_URL.BASE_API_URL.SnapShot + API_URL.ANNUAL_SUMMARY.TOTAL_LY_DATEWISE,
            body: { asofdate: para?.asOfDate, year: selectedYear, propertycode: para?.propertyCode }
        }, false);
        let response = apiResponse(false, totalLyDetailResponse);
        if (response?.isValidate) { setTotalLyData(response?.data?.data); } else { setTotalLyData([]); }
        setTotalLyLoading(false);
    };

    const getBudgetDetail = async () => {
        setBudgetLoading(true);
        let budgetDetailResponse = await apiCall({
            method: "POST",
            url: API_URL.BASE_API_URL.SnapShot + API_URL.ANNUAL_SUMMARY.BUDGET,
            body: { AsOfDate: para?.asOfDate, year: selectedYear, propertyCode: para?.propertyCode }
        }, false);
        let response = apiResponse(false, budgetDetailResponse);
        if (response?.isValidate) { setBudgetData(response?.data?.data); } else { setBudgetData([]); }
        setBudgetLoading(false);
    };

    const getRmsDetail = async () => {
        setEmaForecastLoading(true);
        let rmsDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.FORECAST.RMS_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, rmsDetailResponse);
        if (response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: response?.data?.data,
            };
            setEmaForecastData(response?.data?.data);
            setEmaForecastLoading(false);
        }

        if (!response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: [],
            };
            setEmaForecastData(emaForecastTableData);
            setEmaForecastLoading(false);
        }
    };

    const getEmaForecastDetail = async () => {
        setEmaForecastLoading(true);
        let budgetDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.FORECAST.SPIDER_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, budgetDetailResponse);
        if (response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: response?.data?.data,
            };
            setEmaForecastData(response?.data?.data);
            setEmaForecastLoading(false);
        }

        if (!response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: [],
            };
            setEmaForecastData(emaForecastTableData);
            setEmaForecastLoading(false);
        }
    };

    const getUserDetail = async () => {
        setEmaForecastLoading(true);
        let userDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.FORECAST.USER_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, userDetailResponse);
        if (response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: response?.data?.data,
            };
            setEmaForecastData(response?.data?.data);
            setEmaForecastLoading(false);
        }

        if (!response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                System_forecast: [],
            };
            setEmaForecastData(emaForecastTableData);
            setEmaForecastLoading(false);
        }
    };

    const getOnceNovaDetail = async () => {
        setNovaForecastLoading(true);
        let userDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.FORECAST.NOVA_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, userDetailResponse);
        if (response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                Nova_forecast: response?.data?.data,
            };
            setNovaForecastLoading(false);
        }

        if (!response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                Nova_forecast: [],
            };
            setNovaForecastLoading(false);
        }
    };

    const getNovaDetail = async () => {
        setEmaForecastLoading(true);
        let userDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.FORECAST.NOVA_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, userDetailResponse);
        if (response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                Nova_forecast: response?.data?.data,
            };
            setEmaForecastData(response?.data?.data);
            setEmaForecastLoading(false);
        }

        if (!response?.isValidate) {
            commentPayloadRef.current = {
                ...commentPayloadRef.current,
                Nova_forecast: [],
            };
            setEmaForecastData(emaForecastTableData);
            setEmaForecastLoading(false);
        }
    };

    const [tblids] = useState({
        AnnualSummaryMonth: commonService.GenerateGUID(),
        onThebookWidget: commonService.GenerateGUID(),
        netStlyWidget: commonService.GenerateGUID(),
        totalLyWidget: commonService.GenerateGUID(),
        budgetWidget: commonService.GenerateGUID(),
        emaForecast: commonService.GenerateGUID(),
    });

    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.onThebookWidget} .perbackground-rev`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.netStlyWidget} .perbackground-rev`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.totalLyWidget} .perbackground-rev`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.budgetWidget} .perbackground-rev`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.emaForecast} .perbackground-rev`
    );

    useEffect(() => {
        if (api === 0) {
            setOTBData(OTBTableData);
            setNetStlyData(netStlyTableData);
            setTotalLyData(totalLyTableData);
            setBudgetData(budgetTableData);
            setEmaForecastData(emaForecastTableData);
        } else {
            if (para?.asOfDate) {
                getSevenPickupFromData(selectedYear, pickupDate);
                getORGDetail()
                getNetStlyDetail("netStly");
                getTotalLyDetail();
                getBudgetDetail()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [para?.asOfDate, selectedYear]);

    useEffect(() => {
        if (api === 0) {
            setEmaForecastData(emaForecastTableData);
        } else {
            if (para?.asOfDate) {
                getEmaForecastDetail();
            }
        }
    }, [para?.asOfDate]);

    useEffect(() => {
        if (api === 1 && para?.asOfDate) {
            if (selectedForecast === "ema") {
                getEmaForecastDetail();
            } else if (selectedForecast === "rms") {
                getRmsDetail();
            } else if (selectedForecast === "user") {
                getUserDetail();
            } else if (selectedForecast === "nova") {
                getNovaDetail();
            }
        }
    }, [selectedYear, selectedForecast]);

    useEffect(() => {
        commonService.setAttrDataOfFromTableHeaders(tblids.AnnualSummaryMonth);
        commonService.setAttrDataOfFromTableHeaders(tblids.onThebookWidget);
        commonService.setAttrDataOfFromTableHeaders(tblids.netStlyWidget);
        commonService.setAttrDataOfFromTableHeaders(tblids.totalLyWidget);
        commonService.setAttrDataOfFromTableHeaders(tblids.budgetWidget);
        commonService.setAttrDataOfFromTableHeaders(tblids.emaForecast);
    }, [
        OTBData,
        netStlyData,
        totalLyData,
        budgetData,
        emaForecastData,
        selectedSTLY,
        selectedForecast,
        showVariance,
        selectedBudgetVariance,
        selectedForecastVariance,
        tblids.AnnualSummaryMonth,
        tblids.onThebookWidget,
        tblids.netStlyWidget,
        tblids.totalLyWidget,
        tblids.budgetWidget,
        tblids.emaForecast,
    ]);

    let AllWidgetContainer = document.getElementById(
        "AnnualSummaryAllWidgetInSingle"
    );
    if (AllWidgetContainer !== null) {
        let CW = AllWidgetContainer.clientWidth;
        CW = CW - 120;
        CW = Math.round(CW / 5);
        if (CW < 250) {
            CW = 250;
        }
        let Widget = AllWidgetContainer.getElementsByClassName(
            "allTableTogather-widget"
        );
        if (Widget !== null && Widget.length !== 0) {
            for (let i = 0; i < Widget.length; i++) {
                Widget[i].style.width = CW + "px";
            }
        }
    }

    const handleExport = async (type) => {
        let tableId = document.querySelector("#AnnualSummaryAllWidgetInSingle");

        if (tableId.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }

        let groupingJson = {
            data: [],
            filename: `${para?.propertyCode}-Annual Summary-${moment(
                new Date()
            ).format("MMDDYYYY")}`,
        };

        let groupingRowData = [
            {
                widgetname: "AnnualSummaryDrilldown",
                rowdata: [],
            },
        ];
        let totalJson = [
            {
                widgetname: "BlankCommon",
                rowdata: [{ data: ["Total"] }],
            },
        ];

        let rowItem = document.querySelector("#AnnualSummaryAllWidgetInSingle");


        groupingRowData[0].rowdata.push({
            data: para?.rowTitle ? [para?.rowTitle] : [],
        });
        groupingRowData[0].rowdata.push({
            data: [],
        });

        let findMonthTable = rowItem?.querySelector(
            ".allTableTogatherWrapper .ViewPropertySetupTable table"
        );

        let findMonthTableHeader = findMonthTable?.querySelectorAll("thead tr");
        let findMonthTableTbody = findMonthTable?.querySelectorAll("tbody tr");

        findMonthTableHeader?.forEach((tblHeaderItem, tblHeaderIndex) => {
            if (tblHeaderIndex === 0) {
                let text = tblHeaderItem.querySelector("tr th span").innerText;
                groupingRowData[0].rowdata.push({
                    data: [text ? text : ""],
                });
            } else {
                let text = tblHeaderItem.querySelector("tr th").innerText;
                groupingRowData[0].rowdata.push({
                    data: [text ? text : ""],
                });
            }
        });

        findMonthTableTbody?.forEach((tblBodyItem, tblBodyIndex) => {
            let text = tblBodyItem.querySelector("td").innerText;

            if (findMonthTableTbody?.length - 1 === tblBodyIndex) {
            } else {
                groupingRowData[0].rowdata.push({
                    data: [text ? text : ""],
                });
            }
        });

        const getAllTableData = (tbl) => {
            let findMonthTable = tbl?.querySelector(
                ".allTableTogather-widget .ViewPropertySetupTable table"
            );

            let findMonthTableHeader = findMonthTable?.querySelectorAll("thead tr");
            let findMonthTableTbody = findMonthTable?.querySelectorAll("tbody tr");

            findMonthTableHeader.forEach((tblHeaderItem, tblHeaderIndex) => {
                let tblTh = tblHeaderItem.querySelectorAll("tr th");
                let tblSpan = "";
                if (rowIndex === 0) {
                    tblSpan = tblHeaderItem.querySelector("tr th span");
                }

                tblTh?.forEach((tblThItem) => {
                    let datePickerExists = tblThItem.querySelector(
                        ".react-datepicker-wrapper"
                    );

                    let varianceClassExists =
                        tblThItem.classList.contains("varianceField");

                    if (!datePickerExists) {
                        if (!varianceClassExists) {
                            let text = tblSpan ? tblSpan?.innerText : tblThItem?.innerText;
                            groupingRowData[0].rowdata[tblHeaderIndex + 2].data.push(
                                text ? (text === "ema" ? "SYSTEM" : text) : ""
                            );
                        }
                    } else if (tblThItem?.querySelector("span")) {
                        let text = tblThItem.querySelector("span").innerText;
                        groupingRowData[0].rowdata[tblHeaderIndex + 2].data.push(text);
                    }
                });
            });

            findMonthTableTbody.forEach((tblBodyItem, tblBodyIndex) => {
                let tblTd = tblBodyItem.querySelectorAll("td");

                tblTd?.forEach((tblTdItem, tblTdIndex) => {
                    let text = tblTdItem?.innerText;
                    let varianceClassExists = tblTdItem.classList.contains("d-none");
                    if (!varianceClassExists) {
                        if (findMonthTableTbody?.length - 1 === tblBodyIndex) {
                            totalJson[0].rowdata[0].data.push(text ? text : "");
                        } else {
                            groupingRowData[0].rowdata[tblBodyIndex + 4].data.push(
                                text ? text : ""
                            );
                        }
                    }
                });
            });
        };

        let findOtherTable = rowItem?.querySelectorAll(
            ".allTableTogather .allTableTogather-widget"
        );

        findOtherTable?.forEach((otherTblItem) => {
            getAllTableData(otherTblItem);
        });

        groupingJson.data = [...groupingJson.data, ...groupingRowData];
        groupingJson.data = [...groupingJson.data, ...totalJson];
        groupingJson = {
            ...groupingJson,
            snapshotid: snapshotId ? parseInt(snapshotId) : 0,
            sendtoemails: userDetail?.email ? userDetail?.email : "",
            actiontype: type,
            asofdata: para?.asOfDate
                ? commonService.getDateInDBFormat(para?.asOfDate)
                : "",
        };
        await commonService.widgetWiseExportExcel(groupingJson);
    };

    const handleChatBotJson = async () => {
        let tableId = document?.querySelector("#AnnualSummaryAllWidgetInSingle");

        if (tableId?.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }
        let groupingJson = {
            data: [
                { month: "January" },
                { month: "February" },
                { month: "March" },
                { month: "April" },
                { month: "May" },
                { month: "June" },
                { month: "July" },
                { month: "August" },
                { month: "September" },
                { month: "October" },
                { month: "November" },
                { month: "December" },
            ],
        };

        let getAllTable = tableId?.querySelectorAll(
            ".allTableTogather .allTableTogather-widget .ViewPropertySetupTable .stripped__table table"
        );

        getAllTable?.forEach((tableItem, tableIndex) => {
            let getTbody = tableItem?.querySelectorAll("tbody tr");
            let tableName = "otb";
            if (tableIndex === 1) {
                tableName = "stly";
            } else if (tableIndex === 2) {
                tableName = "ly";
            } else if (tableIndex === 3) {
                tableName = "budget";
            } else if (tableIndex === 4) {
                tableName = "forecast";
            }

            getTbody?.forEach((tbodyItem, tbodyIndex) => {
                let getAllTds = tbodyItem?.querySelectorAll("td");

                getAllTds?.forEach((tdItem, tdIndex) => {
                    if (tbodyIndex !== getTbody?.length - 1) {
                        let keyName = "occ";
                        if (tdIndex === 1) {
                            keyName = "rms";
                        } else if (tdIndex === 2) {
                            keyName = "adr";
                        } else if (tdIndex === 3) {
                            keyName = "rev";
                        }

                        groupingJson.data[tbodyIndex] = {
                            ...groupingJson.data[tbodyIndex],
                            [`${tableName}${keyName}`]: tdItem?.innerText
                                ? tdItem?.innerText
                                : "",
                        };
                    }
                });
            });
        });
        chatApiPayloadRef.current = groupingJson;
        setShowChatModal(true);
        return groupingJson;
    };

    const getVarianceData = async () => {
        let varianceDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.ANNUAL_SUMMARY.GET_VARIANCE_DATEWISE,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, varianceDataResponse);

        if (response?.isValidate) {
            setVarianceData(response?.data?.data);
        }

        if (!response?.isValidate) {
            setVarianceData(null);
        }
    };

    const getBudgetVariance = async () => {
        let budgetVarinaceResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.ANNUAL_SUMMARY.GET_BUDGET_VARIANCE,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, budgetVarinaceResponse);

        if (response?.isValidate) {
            setBudgetVarianceData(response?.data?.data);
        }

        if (!response?.isValidate) {
            setBudgetVarianceData(null);
        }
    };

    const getForecastVariance = async () => {
        let forecastVarianceApi =
            API_URL.ANNUAL_SUMMARY.GET_SYSTEM_FORECAST_VARIANCE;

        if (selectedForecast === "rms") {
            forecastVarianceApi = API_URL.ANNUAL_SUMMARY.GET_RMS_FORECAST_VARIANCE;
        } else if (selectedForecast === "user") {
            forecastVarianceApi = API_URL.ANNUAL_SUMMARY.GET_USER_FORECAST_VARIANCE;
        }
        else if (selectedForecast === "nova") {
            forecastVarianceApi = API_URL.ANNUAL_SUMMARY.GET_NOVA_FORECAST_VARIANCE;
        }
        let forecastVarinaceResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + forecastVarianceApi,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, forecastVarinaceResponse);

        if (response?.isValidate) {
            setForecastVarianceData(response?.data?.data);
        }

        if (!response?.isValidate) {
            setForecastVarianceData(null);
        }
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getVarianceData();
                getBudgetVariance();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [para?.asOfDate, selectedYear]);

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getForecastVariance();
            }
        }
    }, [para?.asOfDate, selectedYear, selectedForecast]);

    const getTotalAdr = (type) => {
        let finalAdr = 0;
        let otbTotalAdr =
            otbrev !== 0 && otbrms !== 0 ? parseInt(otbrev / otbrms) : 0;
        if (type === "netStly") {
            let netStlyTotalAdr =
                netStlyRev !== 0 && netStlyRms !== 0
                    ? parseInt(netStlyRev / netStlyRms)
                    : 0;
            finalAdr =
                otbTotalAdr && netStlyTotalAdr ? otbTotalAdr - netStlyTotalAdr : 0;
        } else if (type === "totalLy") {
            let totalLyTotalAdr =
                totalLyRev !== 0 && totalLyRms !== 0
                    ? parseInt(totalLyRev / totalLyRms)
                    : 0;
            finalAdr =
                otbTotalAdr && totalLyTotalAdr ? otbTotalAdr - totalLyTotalAdr : 0;
        } else if (type === "Budget") {
            let BudgetTotalAdr =
                budgetRev !== 0 && budgetRms !== 0
                    ? parseInt(budgetRev / budgetRms)
                    : 0;
            finalAdr =
                otbTotalAdr && BudgetTotalAdr ? otbTotalAdr - BudgetTotalAdr : 0;
        } else if (type === "forecast") {
            let forecastAdr =
                emaForecastRev !== 0 && emaForecastRms !== 0
                    ? parseInt(emaForecastRev / emaForecastRms)
                    : 0;
            finalAdr = otbTotalAdr && forecastAdr ? otbTotalAdr - forecastAdr : 0;
        }
        return finalAdr;
    };

    const getTotalAdrForBudget = (type) => {
        let finalAdr = 0;
        let budgetTotalAdr =
            budgetRev !== 0 && budgetRms !== 0 ? parseInt(budgetRev / budgetRms) : 0;

        if (type === "otb") {
            let otbTotalAdr =
                otbrev !== 0 && otbrms !== 0 ? parseInt(otbrev / otbrms) : 0;
            finalAdr =
                budgetTotalAdr && otbTotalAdr ? budgetTotalAdr - otbTotalAdr : 0;
        }

        return finalAdr;
    };

    const getTotalAdrVarianceForBudget = (type) => {
        let finalAdrVariance = 0;
        let budgetTotalAdr =
            budgetRev !== 0 && budgetRms !== 0 ? parseInt(budgetRev / budgetRms) : 0;

        if (type === "otb") {
            let otbTotalAdr =
                otbrev !== 0 && otbrms !== 0 ? parseInt(otbrev / otbrms) : 0;
            finalAdrVariance =
                budgetTotalAdr > 0 && otbTotalAdr > 0
                    ? (budgetTotalAdr * 100) / otbTotalAdr - 100
                    : 0;
        }

        return finalAdrVariance;
    };

    const valueForBudgetVariance = (keyName, data) => {
        return data?.[0]?.[keyName] ? data?.[0]?.[keyName] : 0;
    };

    const updateTableTotalValue = (
        tableId,
        currentTblAdrTotal,
        currentTblRevTotal,
        varianceType
    ) => {
        let budgetTotalAdr =
            budgetRev !== 0 && budgetRms !== 0 ? parseInt(budgetRev / budgetRms) : 0;

        let forecastTotalAdr =
            emaForecastRev !== 0 && emaForecastRms !== 0
                ? parseInt(emaForecastRev / emaForecastRms)
                : 0;
        let findTable = document.getElementById(tableId);

        let tblBody = findTable?.querySelectorAll("tbody tr");

        let lastRow = tblBody[tblBody?.length - 1];
        let lastRowAllTd = lastRow?.querySelectorAll("td");

        let budgetFinalAdr = budgetTotalAdr - currentTblAdrTotal;

        let ForecastFinalAdr = forecastTotalAdr - currentTblAdrTotal;

        let budgetFinalAdrVariance =
            budgetTotalAdr && currentTblAdrTotal
                ? (budgetTotalAdr * 100) / currentTblAdrTotal - 100
                : 0;

        let forecastFinalAdrVariance =
            forecastTotalAdr && currentTblAdrTotal
                ? (forecastTotalAdr * 100) / currentTblAdrTotal - 100
                : 0;

        let budgetFinalRev = budgetRev - currentTblRevTotal;

        let forecastFinalRev = emaForecastRev - currentTblRevTotal;

        let budgetFinalRevVariance =
            budgetRev && currentTblRevTotal
                ? (budgetRev * 100) / currentTblRevTotal - 100
                : 0;

        let forecastFinalRevVariance =
            emaForecastRev && currentTblRevTotal
                ? (emaForecastRev * 100) / currentTblRevTotal - 100
                : 0;

        lastRowAllTd?.forEach((item, index) => {
            if (varianceType === "budget") {
                if (index === 2) {
                    item.innerText = `${commonService.formateAmount(budgetFinalAdr)}`;
                }
                if (index === 3) {
                    item.innerText = `${budgetFinalAdrVariance?.toFixed(1)}%`;
                }
                if (index === 4) {
                    item.innerText = `${commonService.formateAmount(budgetFinalRev)}`;
                }
                if (index === 5) {
                    item.innerText = `${budgetFinalRevVariance?.toFixed(1)}%`;
                }
            } else if (varianceType === "forecast") {
                if (index === 2) {
                    item.innerText = `${commonService.formateAmount(ForecastFinalAdr)}`;
                }
                if (index === 3) {
                    item.innerText = `${forecastFinalAdrVariance?.toFixed(1)}%`;
                }
                if (index === 4) {
                    item.innerText = `${commonService.formateAmount(forecastFinalRev)}`;
                }
                if (index === 5) {
                    item.innerText = `${forecastFinalRevVariance?.toFixed(1)}%`;
                }
            }
        });
    };

    const getTotalForVariance = () => {
        if (selectedBudgetVariance === "otb") {
            let otbTotalAdr =
                otbrev !== 0 && otbrms !== 0 ? parseInt(otbrev / otbrms) : 0;

            updateTableTotalValue(
                tblids.onThebookWidget,
                otbTotalAdr,
                otbrev,
                "budget"
            );
        } else if (selectedForecastVariance === "otb") {
            let otbTotalAdr =
                otbrev !== 0 && otbrms !== 0 ? parseInt(otbrev / otbrms) : 0;

            updateTableTotalValue(
                tblids.onThebookWidget,
                otbTotalAdr,
                otbrev,
                "forecast"
            );
        } else if (selectedBudgetVariance === "netStly") {
            let netStlyTotalAdr =
                netStlyRev !== 0 && netStlyRms !== 0
                    ? parseInt(netStlyRev / netStlyRms)
                    : 0;

            updateTableTotalValue(
                tblids.netStlyWidget,
                netStlyTotalAdr,
                netStlyRev,
                "budget"
            );
        } else if (selectedForecastVariance === "netStly") {
            let netStlyTotalAdr =
                netStlyRev !== 0 && netStlyRms !== 0
                    ? parseInt(netStlyRev / netStlyRms)
                    : 0;

            updateTableTotalValue(
                tblids.netStlyWidget,
                netStlyTotalAdr,
                netStlyRev,
                "forecast"
            );
        } else if (selectedBudgetVariance === "totalLy") {
            let totalLyTotalAdr =
                totalLyRev !== 0 && totalLyRms !== 0
                    ? parseInt(totalLyRev / totalLyRms)
                    : 0;

            updateTableTotalValue(
                tblids.totalLyWidget,
                totalLyTotalAdr,
                totalLyRev,
                "budget"
            );
        } else if (selectedForecastVariance === "totalLy") {
            let totalLyTotalAdr =
                totalLyRev !== 0 && totalLyRms !== 0
                    ? parseInt(totalLyRev / totalLyRms)
                    : 0;

            updateTableTotalValue(
                tblids.totalLyWidget,
                totalLyTotalAdr,
                totalLyRev,
                "forecast"
            );
        } else if (selectedForecastVariance === "budget") {
            let budgetTotalAdr =
                budgetRev !== 0 && budgetRms !== 0
                    ? parseInt(budgetRev / budgetRms)
                    : 0;

            updateTableTotalValue(
                tblids.budgetWidget,
                budgetTotalAdr,
                budgetRev,
                "forecast"
            );
        } else if (
            selectedBudgetVariance === "ema" ||
            selectedBudgetVariance === "rms" ||
            selectedBudgetVariance === "user" ||
            selectedBudgetVariance === "nova"
        ) {
            let forecastTotalAdr =
                emaForecastRev !== 0 && emaForecastRms !== 0
                    ? parseInt(emaForecastRev / emaForecastRms)
                    : 0;

            updateTableTotalValue(
                tblids.emaForecast,
                forecastTotalAdr,
                emaForecastRev,
                "budget"
            );
        }
    };

    const handleAnnualSummaryChat = () => {
        let tableId = document?.querySelector("#AnnualSummaryAllWidgetInSingle");

        if (tableId?.querySelector(".loding-animation")) {
            errorToastMessage("Wait for the data loading.");
            return;
        }
        let groupingJson = {
            propertyid: para?.propertyDetail?.propertyid,
            clientid: userDetail?.clientid,
            userid: userDetail?.userid,
            prompt: "Please generate summary",
            json: {},
        };

        let getAllTable = tableId?.querySelectorAll(
            ".allTableTogather .allTableTogather-widget .ViewPropertySetupTable .stripped__table table"
        );

        getAllTable?.forEach((tableItem, tableIndex) => {
            let getTbody = tableItem?.querySelectorAll("tbody tr");
            let tableName = "On The Books";
            if (tableIndex === 1) {
                tableName = "Net STLY";
            } else if (tableIndex === 2) {
                tableName = "Total LY";
            } else if (tableIndex === 3) {
                tableName = "Budget";
            } else if (tableIndex === 4) {
                tableName = "Forecast";
            }
            let arr = [];
            const removeSymbol = (value) => {
                let data = value?.replaceAll("$", "");
                let finalValue = data?.replaceAll(",", "");
                return finalValue;
            };

            getTbody?.forEach((tbodyItem, tbodyIndex) => {
                if (tbodyIndex !== getTbody?.length - 1) {
                    let getAllTds = tbodyItem?.querySelectorAll("td");
                    let obj = {
                        propertyCode: para?.propertyCode,
                        AsOfDate: para?.asOfDate,
                        year: selectedYear,
                        month: month[tbodyIndex],
                    };

                    getAllTds?.forEach((tdItem, tdIndex) => {
                        if (tbodyIndex !== getTbody?.length - 1) {
                            if (tdIndex == 0) {
                                obj.occ = removeSymbol(tdItem?.innerText);
                            } else if (tdIndex === 1) {
                                obj.rms = removeSymbol(tdItem?.innerText);
                            } else if (tdIndex === 2) {
                                obj.adr = removeSymbol(tdItem?.innerText);
                            } else if (tdIndex === 3) {
                                obj.rev = removeSymbol(tdItem?.innerText);
                            }
                        }
                    });
                    arr.push(obj);
                }
            });
            groupingJson.json[tableName] = arr;
        });
    };

    const aiGeneratedComment = async () => {
    };

    useEffect(() => {
        if (
            !otbLoading &&
            !budgetLoading &&
            !netStlyLoading &&
            !totalLyLoading &&
            !emaForecastLoading &&
            !novaForecastLoading &&
            !aiGenerateCommentApiCalledRef.current
        ) {
            aiGeneratedComment();
        }
    }, [
        otbLoading,
        budgetLoading,
        netStlyLoading,
        totalLyLoading,
        emaForecastLoading,
        novaForecastLoading,
    ]);

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                if (
                                    window.location.href.includes(
                                        "Annual%20Summary%20(RevPAK)"
                                    ) ||
                                    window.location.href.includes("RevPAK%20Summary")
                                ) {
                                    handleExport("EMAIL");
                                } else {
                                    commonService.fnSendWidgetMail(
                                        tblids.AnnualSummaryMonth +
                                        "," +
                                        tblids.onThebookWidget +
                                        "," +
                                        tblids.netStlyWidget +
                                        "," +
                                        tblids.totalLyWidget +
                                        "," +
                                        tblids.budgetWidget +
                                        "," +
                                        tblids.emaForecast,
                                        "Annual Summary",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.AnnualSummaryMonth +
                                "," +
                                tblids.onThebookWidget +
                                "," +
                                tblids.netStlyWidget +
                                "," +
                                tblids.totalLyWidget +
                                "," +
                                tblids.budgetWidget +
                                "," +
                                tblids.emaForecast
                            }
                            onClick={() => {
                                if (
                                    window.location.href.includes(
                                        "Annual%20Summary%20(RevPAK)"
                                    ) ||
                                    window.location.href.includes("RevPAK%20Summary")
                                ) {
                                    handleExport("DOWNLOAD");
                                } else {
                                    commonService.fnExportInCSV(
                                        tblids.AnnualSummaryMonth +
                                        "," +
                                        tblids.onThebookWidget +
                                        "," +
                                        tblids.netStlyWidget +
                                        "," +
                                        tblids.totalLyWidget +
                                        "," +
                                        tblids.budgetWidget +
                                        "," +
                                        tblids.emaForecast,
                                        `${para?.propertyCode}-Annual Summary-${moment(
                                            new Date()
                                        ).format("MMDDYYYY")}`
                                    );
                                }
                            }}
                        />
                    </Button>
                </div>
            )}

            <div
                className="allTableTogatherWrapper"
                id="AnnualSummaryAllWidgetInSingle"
                onMouseOver={(e) => {
                    const tr = e.target.closest("tbody > tr");
                    if (tr === hoverRowRef.current) return;
                    document
                        .querySelectorAll("#AnnualSummaryAllWidgetInSingle tr.row-zoom")
                        .forEach((r) => r.classList.remove("row-zoom"));
                    hoverRowRef.current = tr;
                    if (!tr) return;
                    const idx = tr.sectionRowIndex;
                    document
                        .querySelectorAll("#AnnualSummaryAllWidgetInSingle .stripped__table table > tbody")
                        .forEach((tb) => tb.rows[idx]?.classList.add("row-zoom"));
                }}
                onMouseLeave={() => {
                    hoverRowRef.current = null;
                    document
                        .querySelectorAll("#AnnualSummaryAllWidgetInSingle tr.row-zoom")
                        .forEach((r) => r.classList.remove("row-zoom"));
                }}
            >
                <div style={{ display: "flex", gridGap: "10px" }}>
                    <div style={{ width: "135px", flex: "none" }}>
                        <div className="ViewPropertySetupTable monthSelectTable nowrap">
                            <div className="stripped__table">
                                <Table id={tblids.AnnualSummaryMonth} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div>
                                                    <Form.Select id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "month", propertyCode)}
                                                        value={selectedYear}
                                                        onChange={(e) => {
                                                            setSelectedYear(e.target.value);
                                                            setExpandedMonth(null);
                                                            setExpandedDailyData({});
                                                        }}
                                                        style={{ padding: 0 }}
                                                    >
                                                        <option value="">Select</option>
                                                        {yearsArr?.map((item, index) => (
                                                            <option key={index} value={item}>
                                                                {item}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <span style={{ display: "none" }}>
                                                        {selectedYear}
                                                    </span>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Month</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {month?.map((item, index) => (
                                            <React.Fragment key={item}>
                                                <tr onClick={() => toggleMonth(item)} style={{ cursor: "pointer" }}>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-between" style={{ height: "20px", lineHeight: "1" }}>
                                                            <span className="text-nowrap">
                                                                {expandedMonth === item ? "-" : "+"} {item}
                                                            </span>
                                                            {(() => {
                                                                let monthEvents = getMonthEvents(item);
                                                                return monthEvents?.length > 0 ? (
                                                                    <span
                                                                        className="d-flex align-items-center gap-1 cursorPointer"
                                                                        id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "monthEventsBadge", item)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            fontWeight: "600",
                                                                            color: "#2563eb",
                                                                            backgroundColor: "#eff6ff",
                                                                            border: "1px solid #bfdbfe",
                                                                            padding: "1px 5px",
                                                                            borderRadius: "10px",
                                                                            lineHeight: "1",
                                                                            marginRight: "2px",
                                                                            flexShrink: 0,
                                                                        }}
                                                                        title={`${monthEvents.length} event${monthEvents.length > 1 ? "s" : ""}: ${monthEvents.map(e => e.name).filter(Boolean).slice(0, 3).join(", ")}${monthEvents.length > 3 ? "..." : ""}`}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            selectedEventDateRef.current = moment(`01-${item}-${selectedYear}`).format("YYYY-MM-DD");
                                                                            eventListPropsRef.current = monthEvents;
                                                                            setShowTicketModal(true);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={ticket}
                                                                            alt="ticket"
                                                                            style={{ width: "10px", height: "10px" }}
                                                                            className="iconcolor"
                                                                        />
                                                                        {monthEvents.length}
                                                                    </span>
                                                                ) : null;
                                                            })()}
                                                        </div>
                                                    </td>
                                                </tr>
                                                {expandedMonth === item && (
                                                    getDaysInMonth(item, selectedYear).map((dateStr, dIdx) => {
                                                        let checkEvent = (eventListRef.current || eventListState)?.filter((x) => {
                                                            let checkingDate = moment(dateStr);
                                                            let startingDate = moment(x?.startDate);
                                                            let endingDate = moment(x?.endDate);
                                                            return (
                                                                checkingDate.isSameOrAfter(startingDate, "day") &&
                                                                checkingDate.isSameOrBefore(endingDate, "day")
                                                            );
                                                        });

                                                        let checkNoteExists = noteDetail?.notedata?.filter(
                                                            (x) =>
                                                                moment(x?.datadate).format("YYYY-MM-DD") ===
                                                                moment(dateStr).format("YYYY-MM-DD")
                                                        );

                                                        return (
                                                            <tr key={dIdx} className="expanded-row">
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-between gap-1" style={{ height: "20px", lineHeight: "1" }}>
                                                                        <span className="ms-2 text-nowrap" style={{ fontSize: "11px", lineHeight: "1" }}>{moment(dateStr).format("D ddd")}</span>
                                                                        <div className="d-flex align-items-center gap-1">
                                                                            {checkEvent?.length > 0 && (
                                                                                <img
                                                                                    style={{ height: "11px", width: "11px", cursor: "pointer" }}
                                                                                    className="iconcolor cursorPointer"
                                                                                    src={ticket}
                                                                                    alt="ticket"
                                                                                    id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "checkEventIcon", commonService.getDateInFormat(dateStr))}
                                                                                    onClick={() => {
                                                                                        selectedEventDateRef.current = dateStr;
                                                                                        eventListPropsRef.current = checkEvent;
                                                                                        setShowTicketModal(true);
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            <img
                                                                                id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", checkNoteExists?.length > 0 ? "dark-notesIcon" : "notesIcon", commonService.getDateInFormat(dateStr))}
                                                                                className="cursorPointer"
                                                                                style={{ height: "12px", width: "12px", cursor: "pointer" }}
                                                                                src={checkNoteExists?.length > 0 ? darkNoteIcon : NoteIcon}
                                                                                onClick={() => {
                                                                                    clickedDateForNote.current = dateStr;
                                                                                    setShowDailyNoteSidebar(true);
                                                                                }}
                                                                                alt="note"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                )}
                                            </React.Fragment>
                                        ))}
                                        <tr>
                                            <td className="boldTd">Total</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ flex: "1" }}>
                        <div
                            className="allTableTogather"
                            style={{ display: "flex", gridGap: "5px", maxWidth: "calc(100vw - 200px)" }}
                        >
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table id={tblids.onThebookWidget} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan={2}
                                                        className="text-center"
                                                    >
                                                        {selectedBudgetVariance === "otb"
                                                            ? "Budget vs OTB"
                                                            : selectedForecastVariance === "otb"
                                                                ? "Forecast vs OTB"
                                                                : "OTB"}
                                                    </th>
                                                    <th colSpan={2} className="varianceField">
                                                        <div className="form-check form-switch no-border-break from-groups jay-put-this-checkbox">
                                                            <input id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "variance-rms", propertyCode)}
                                                                className="form-check-input me-2"
                                                                type="checkbox"
                                                                role="switch"
                                                                checked={showVariance}
                                                                onChange={() => {
                                                                    setSelectedBudgetVariance("");
                                                                    setShowVariance(!showVariance);
                                                                }}
                                                            />
                                                            <label className="form-check-label">
                                                                Variance
                                                            </label>
                                                        </div>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>OCC</th>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className="text-end">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {api === 0 ? (
                                                    OTBData?.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={index}>
                                                                <td>{item?.occ}%</td>
                                                                <td className="text-center">{item?.rms}</td>
                                                                <td className="text-end">${item?.adr}</td>
                                                                <td
                                                                    className="text-end perbackground perbackground-rev"
                                                                    value={item?.rev}
                                                                >
                                                                    ${item?.rev}
                                                                </td>
                                                            </tr>
                                                            {index === OTBData?.length - 1 && (
                                                                <tr>
                                                                    <td className="boldTd">0%</td>
                                                                    <td className="boldTd text-center">0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : otbLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={4} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    (OTBData ||
                                                        budgetVarianceData ||
                                                        forecastVarianceData) &&
                                                    month?.map((item, index) => {
                                                        let findMonthData = OTBData?.filter((x) => x.month === item);
                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        let findBudgetVarianceData =
                                                            budgetVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let findForecastVarianceData =
                                                            forecastVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let occ = 0,
                                                            rms = 0,
                                                            adr = 0,
                                                            rev = 0,
                                                            adrVariance = 0,
                                                            revVariance = 0;

                                                        otbrms =
                                                            otbrms +
                                                            rms;
                                                        otbadr =
                                                            otbadr +
                                                            adr;
                                                        otbrev =
                                                            otbrev +
                                                            rev;

                                                        if (selectedBudgetVariance === "otb") {
                                                            occ = valueForBudgetVariance(
                                                                "OTB_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "OTB_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "OTB_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "OTB_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            otbocc =
                                                                otbocc +
                                                                valueForBudgetVariance(
                                                                    "OTB_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            budgetVarianceOtbRms =
                                                                budgetVarianceOtbRms +
                                                                valueForBudgetVariance(
                                                                    "OTB_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedForecastVariance === "otb") {
                                                            let keyName = "Forecast";
                                                            if (selectedForecast === "rms") {
                                                                keyName = "RMS_Forecast";
                                                            } else if (selectedForecast === "user") {
                                                                keyName = "USER_Forecast";
                                                            }
                                                            else if (selectedForecast === "nova") {
                                                                keyName = "NOVA_Forecast";
                                                            }
                                                            occ = valueForBudgetVariance(
                                                                "OTB_OCC",
                                                                findForecastVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "OTB_RMS",
                                                                findForecastVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "OTB_ADR",
                                                                findForecastVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "OTB_REV",
                                                                findForecastVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_ADR`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_ADR`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_REV`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_REV`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            otbocc =
                                                                otbocc +
                                                                valueForBudgetVariance(
                                                                    "OTB_OCC",
                                                                    findForecastVarianceData
                                                                );
                                                            budgetVarianceOtbRms =
                                                                budgetVarianceOtbRms +
                                                                valueForBudgetVariance(
                                                                    "OTB_RMS",
                                                                    findForecastVarianceData
                                                                );
                                                        } else {
                                                            occ = valueForBudgetVariance(
                                                                "occ",
                                                                findMonthData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "rms",
                                                                findMonthData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "adr",
                                                                findMonthData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "rev",
                                                                findMonthData
                                                            );

                                                            otbocc = otbocc + occ;
                                                            otbrms = otbrms + rms;
                                                            otbadr = otbadr + adr;
                                                            otbrev = otbrev + rev;
                                                        }

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td
                                                                        className={`generatesummary ${selectedBudgetVariance === "otb" ||
                                                                            selectedForecastVariance === "otb"
                                                                            ? occ > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {occ}%
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-center ${selectedBudgetVariance === "otb" ||
                                                                            selectedForecastVariance === "otb"
                                                                            ? rms > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateRoom(rms)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${selectedBudgetVariance === "otb" ||
                                                                            selectedForecastVariance === "otb"
                                                                            ? adr > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateAmount(adr)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${selectedBudgetVariance === "otb" ||
                                                                            selectedForecastVariance === "otb"
                                                                            ? ""
                                                                            : "perbackground perbackground-rev"
                                                                            } ${selectedBudgetVariance === "otb" ||
                                                                                selectedForecastVariance === "otb"
                                                                                ? rev > 0
                                                                                    ? "greenText"
                                                                                    : "redText"
                                                                                : ""
                                                                            }`}
                                                                        value={rev}
                                                                    >
                                                                        {commonService.formateAmount(rev)}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    dailyLoading.otb && !expandedDailyData[item]?.otb ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (expandedDailyData[item]?.otb || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let dOcc = dayData.occ || 0;
                                                                            let dRms = dayData.rms || 0;
                                                                            let dAdr = dayData.adr || 0;
                                                                            let dRev = dayData.rev || 0;

                                                                            let isVariance = selectedBudgetVariance === "otb" || selectedForecastVariance === "otb";
                                                                            let vOcc = dOcc;
                                                                            let vRms = dRms;
                                                                            let vAdr = dAdr;
                                                                            let vRev = dRev;

                                                                            if (isVariance) {
                                                                                let baseDay = selectedBudgetVariance === "otb"
                                                                                    ? ((expandedDailyData[item]?.budget || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {})
                                                                                    : ((expandedDailyData[item]?.forecast || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {});
                                                                                vOcc = (baseDay.occ || 0) - (dayData.occ || 0);
                                                                                vRms = (baseDay.rms || 0) - (dayData.rms || 0);
                                                                                vAdr = (baseDay.adr || 0) - (dayData.adr || 0);
                                                                                vRev = (baseDay.rev || 0) - (dayData.rev || 0);
                                                                            }

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary ${isVariance ? (vOcc > 0 ? "greenText" : vOcc < 0 ? "redText" : "") : ""}`}>
                                                                                        {vOcc}%
                                                                                    </td>
                                                                                    <td className="text-center text-primary">
                                                                                        <span
                                                                                            className={`${selectedTdIndexRef.current === dIdx
                                                                                                ? "singleDateSummarySpan"
                                                                                                : ""
                                                                                                }`}
                                                                                            onClick={(e) => {
                                                                                                singleDateSelectedDateRef.current = dateStr;
                                                                                                handleFilterBtnClick(e);
                                                                                                selectedTdIndexRef.current = dIdx;
                                                                                            }}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            {commonService.formateRoom(vRms)}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vAdr > 0 ? "greenText" : vAdr < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vAdr)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vRev > 0 ? "greenText" : vRev < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vRev)}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}

                                                                {index === 11 && (
                                                                    <tr key={index}>
                                                                        <td className="boldTd">
                                                                            {parseInt(otbocc / 12)}%
                                                                        </td>
                                                                        <td className="boldTd text-center">
                                                                            {selectedBudgetVariance === "otb" ||
                                                                                selectedForecastVariance === "otb"
                                                                                ? commonService.formateRoom(
                                                                                    budgetVarianceOtbRms
                                                                                )
                                                                                : commonService.formateRoom(otbrms)}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {selectedBudgetVariance === "otb"
                                                                                ? commonService.formateAmount(
                                                                                    getTotalAdrForBudget("otb")
                                                                                )
                                                                                : otbrev !== 0 && otbrms !== 0
                                                                                    ? commonService.formateAmount(
                                                                                        parseInt(otbrev / otbrms)
                                                                                    )
                                                                                    : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {selectedBudgetVariance === "otb"
                                                                                ? commonService.formateAmount(
                                                                                    budgetRev - otbrev
                                                                                )
                                                                                : commonService.formateAmount(otbrev)}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table responsive id="pickup7days">
                                            <thead>
                                                <tr>
                                                    {/* <th colSpan={2} className="text-center">
                                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                                            <span>PICKUP LAST 1 DAY</span> */}
                                                    <th colSpan={2} className="text-center" style={{ verticalAlign: "middle" }}>
                                                        <div className="d-flex flex-column align-items-center justify-content-center" style={{ gap: "2px" }}>
                                                            <span style={{ whiteSpace: "nowrap", lineHeight: "1.2" }}>PICKUP LAST 1 DAY</span>
                                                            <DatePicker
                                                                id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "pickup-date", propertyCode)}
                                                                portalId="datepicker-root"
                                                                selected={pickupDate ? new Date(pickupDate) : null}
                                                                onChange={(date) => {
                                                                    if (date) {
                                                                        setPickupDate(date);
                                                                        getSevenPickupFromData(selectedYear, date);
                                                                    }
                                                                }}
                                                                maxDate={para?.asOfDate ? new Date(para?.asOfDate) : new Date()}
                                                                className="text-center"
                                                            />
                                                        </div>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-center">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pickupLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={2} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    month?.map((item, index) => {
                                                        let findMonthData = (sevenPickupFromData || []).filter((x) => {
                                                            let d = x.date || x.Date;
                                                            return d && moment(d).format("MMMM") === item && (!selectedYear || moment(d).year() === parseInt(selectedYear));
                                                        });

                                                        let rms = 0, rev = 0;
                                                        if (findMonthData && findMonthData.length > 0) {
                                                            rms = findMonthData.reduce((acc, curr) => acc + (Number(curr.RMS || curr.rms || curr.Rms) || 0), 0);
                                                            rev = findMonthData.reduce((acc, curr) => acc + (Number(curr.REV || curr.rev || curr.Rev) || 0), 0);
                                                        }

                                                        sevenPickupRms = sevenPickupRms + rms;
                                                        sevenPickupRev = sevenPickupRev + rev;

                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td className={`generatesummary text-center ${rms > 0 ? "greenText" : (rms < 0 ? "redText" : "")}`}>
                                                                        {rms > 0 ? `+${rms}` : (rms < 0 ? rms : 0)}
                                                                    </td>
                                                                    <td className={`generatesummary text-center ${rev > 0 ? "greenText" : (rev < 0 ? "redText" : "")}`}>
                                                                        {rev > 0 ? `+${commonService.formateAmount(rev)}` : (rev < 0 ? `-${commonService.formateAmount(Math.abs(rev))}` : commonService.formateAmount(0))}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    pickupLoading ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={2}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (sevenPickupFromData || []).find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let dRms = Number(dayData.RMS || dayData.rms || dayData.Rms) || 0;
                                                                            let dRev = Number(dayData.REV || dayData.rev || dayData.Rev) || 0;

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary text-center ${dRms > 0 ? "greenText" : (dRms < 0 ? "redText" : "")}`}>
                                                                                        {dRms > 0 ? `+${dRms}` : (dRms < 0 ? dRms : 0)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-center ${dRev > 0 ? "greenText" : (dRev < 0 ? "redText" : "")}`}>
                                                                                        {dRev > 0 ? `+${commonService.formateAmount(dRev)}` : (dRev < 0 ? `-${commonService.formateAmount(Math.abs(dRev))}` : commonService.formateAmount(0))}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                                {!pickupLoading && (
                                                    <tr>
                                                        <td className="boldTd text-center">
                                                            <span className={`${sevenPickupRms > 0 ? "greenText" : (sevenPickupRms < 0 ? "redText" : "")}`}>
                                                                {sevenPickupRms > 0 ? `+${sevenPickupRms}` : (sevenPickupRms < 0 ? sevenPickupRms : 0)}
                                                            </span>
                                                        </td>
                                                        <td className="boldTd text-center">
                                                            <span className={`${sevenPickupRev > 0 ? "greenText" : (sevenPickupRev < 0 ? "redText" : "")}`}>
                                                                {sevenPickupRev > 0 ? `+${commonService.formateAmount(sevenPickupRev)}` : (sevenPickupRev < 0 ? `-${commonService.formateAmount(Math.abs(sevenPickupRev))}` : commonService.formateAmount(0))}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table id={tblids.netStlyWidget} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan={4}
                                                        className="text-center"
                                                    >
                                                        <span className="d-flex justify-content-center align-items-center">
                                                            {showVariance ? (
                                                                <span className="me-2 fw-bold text-nowrap">OTB vs</span>
                                                            ) : selectedBudgetVariance === "netStly" ? (
                                                                <span className="me-2 fw-bold text-nowrap">Budget vs</span>
                                                            ) : selectedForecastVariance === "netStly" ? (
                                                                <span className="me-2 fw-bold text-nowrap">Forecast vs</span>
                                                            ) : null}
                                                            <Form.Select id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "occ", propertyCode)}
                                                                className="w-50"
                                                                value={selectedSTLY}
                                                                onChange={(e) => {
                                                                    if (e.target.value !== "") {
                                                                        setShowVariance(false);
                                                                        setSelectedBudgetVariance("");
                                                                    }
                                                                    setSelectedSTLY(e.target.value);
                                                                    getNetStlyDetail(e.target.value)
                                                                    setExpandedMonth(null);
                                                                    setExpandedDailyData({});
                                                                }}
                                                            >
                                                                <option value={"netStly"}>NET STLY</option>
                                                                <option value={"stly"}>STLY</option>
                                                            </Form.Select>
                                                        </span>
                                                        <span style={{ display: "none" }}>
                                                            {commonService.ForecastTypeDisplayLable(selectedSTLY)}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>OCC</th>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className="text-end">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {api === 0 ? (
                                                    netStlyData?.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={index}>
                                                                <td>{item?.occ}%</td>
                                                                <td className="text-center">{item?.rms}</td>
                                                                <td className="text-end">${item?.adr}</td>
                                                                {(showVariance ||
                                                                    selectedBudgetVariance === "netStly") && (
                                                                        <td></td>
                                                                    )}
                                                                <td
                                                                    className="text-end perbackground perbackground-rev"
                                                                    value={item?.rev}
                                                                >
                                                                    ${item?.rev}
                                                                </td>
                                                                {(showVariance ||
                                                                    selectedBudgetVariance === "netStly") && (
                                                                        <td></td>
                                                                    )}
                                                            </tr>
                                                            {index === netStlyData?.length - 1 && (
                                                                <tr>
                                                                    <td className="boldTd">0%</td>
                                                                    <td className="boldTd text-center">0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    {(showVariance ||
                                                                        selectedBudgetVariance === "netStly") && (
                                                                            <td className="boldTd text-end"></td>
                                                                        )}
                                                                    <td className="boldTd text-end">$0</td>
                                                                    {(showVariance ||
                                                                        selectedBudgetVariance === "netStly") && (
                                                                            <td className="boldTd text-end"></td>
                                                                        )}
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : netStlyLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={4} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    (netStlyData ||
                                                        varianceData ||
                                                        budgetVarianceData ||
                                                        forecastVarianceData) &&
                                                    month?.map((item, index) => {
                                                        let findMonthData = netStlyData && netStlyData?.filter((x) => x.month ? x.month === item : (x.date || x.Date ? moment(x.date || x.Date).format("MMMM") === item : false));
                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        let varianceMonthData = varianceData?.filter(
                                                            (x) => x?.month === item
                                                        );

                                                        let findBudgetVarianceData =
                                                            budgetVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let findForecastVarianceData =
                                                            forecastVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let occ = 0,
                                                            rms = 0,
                                                            adr = 0,
                                                            rev = 0,
                                                            adrVariance = 0,
                                                            revVariance = 0;
                                                        netStlyAdr =
                                                            netStlyAdr +
                                                            (findMonthData?.[0]?.adr
                                                                ? findMonthData?.[0]?.adr
                                                                : 0);
                                                        netStlyRev =
                                                            netStlyRev +
                                                            (findMonthData?.[0]?.rev
                                                                ? findMonthData?.[0]?.rev
                                                                : 0);
                                                        netStlyRms =
                                                            netStlyRms +
                                                            (findMonthData?.[0]?.rms
                                                                ? findMonthData?.[0]?.rms
                                                                : 0);
                                                        if (showVariance) {
                                                            occ = varianceMonthData?.[0]?.STLY_OCC
                                                                ? varianceMonthData?.[0]?.STLY_OCC
                                                                : 0;
                                                            rms = varianceMonthData?.[0]?.STLY_RMS
                                                                ? varianceMonthData?.[0]?.STLY_RMS
                                                                : 0;
                                                            adr = varianceMonthData?.[0]?.STLY_ADR
                                                                ? varianceMonthData?.[0]?.STLY_ADR
                                                                : 0;
                                                            rev = varianceMonthData?.[0]?.STLY_REV
                                                                ? varianceMonthData?.[0]?.STLY_REV
                                                                : 0;
                                                            adrVariance =
                                                                varianceMonthData?.[0]?.OTB_ADR > 0 &&
                                                                    findMonthData?.[0]?.adr > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_ADR
                                                                        ? varianceMonthData?.[0]?.OTB_ADR
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.adr
                                                                        ? findMonthData?.[0]?.adr
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(adrVariance) || isNaN(adrVariance)) {
                                                                adrVariance = 0;
                                                            }

                                                            revVariance =
                                                                varianceMonthData?.[0]?.OTB_REV > 0 &&
                                                                    findMonthData?.[0]?.rev > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_REV
                                                                        ? varianceMonthData?.[0]?.OTB_REV
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.rev
                                                                        ? findMonthData?.[0]?.rev
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(revVariance) || isNaN(revVariance)) {
                                                                revVariance = 0;
                                                            }

                                                            netStlyOcc =
                                                                netStlyOcc +
                                                                (varianceMonthData?.[0]?.STLY_OCC
                                                                    ? varianceMonthData?.[0]?.STLY_OCC
                                                                    : 0);
                                                            varianceNetStlyRms =
                                                                varianceNetStlyRms +
                                                                (varianceMonthData?.[0]?.STLY_RMS
                                                                    ? varianceMonthData?.[0]?.STLY_RMS
                                                                    : 0);
                                                        } else if (selectedBudgetVariance === "netStly") {
                                                            occ = valueForBudgetVariance(
                                                                "STLY_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "STLY_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "STLY_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "STLY_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            netStlyOcc =
                                                                netStlyOcc +
                                                                valueForBudgetVariance(
                                                                    "STLY_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceNetStlyRms =
                                                                varianceNetStlyRms +
                                                                valueForBudgetVariance(
                                                                    "STLY_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedForecastVariance === "netStly") {
                                                            let keyName = "Forecast";
                                                            if (selectedForecast === "rms") {
                                                                keyName = "RMS_Forecast";
                                                            } else if (selectedForecast === "user") {
                                                                keyName = "USER_Forecast";
                                                            }
                                                            else if (selectedForecast === "nova") {
                                                                keyName = "NOVA_Forecast";
                                                            }
                                                            occ = valueForBudgetVariance(
                                                                "STLY_OCC",
                                                                findForecastVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "STLY_RMS",
                                                                findForecastVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "STLY_ADR",
                                                                findForecastVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "STLY_REV",
                                                                findForecastVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_ADR`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_ADR`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_REV`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_REV`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            otbocc =
                                                                otbocc +
                                                                valueForBudgetVariance(
                                                                    "STLY_OCC",
                                                                    findForecastVarianceData
                                                                );
                                                            varianceNetStlyRms =
                                                                varianceNetStlyRms +
                                                                valueForBudgetVariance(
                                                                    "STLY_RMS",
                                                                    findForecastVarianceData
                                                                );
                                                        } else {
                                                            occ = findMonthData?.[0]?.occ ? findMonthData?.[0]?.occ : 0;
                                                            rms = findMonthData?.[0]?.rms ? findMonthData?.[0]?.rms : 0;
                                                            adr = findMonthData?.[0]?.adr ? findMonthData?.[0]?.adr : 0;
                                                            rev = findMonthData?.[0]?.rev ? findMonthData?.[0]?.rev : 0;

                                                            netStlyOcc = netStlyOcc + occ;
                                                        }

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td
                                                                        className={`generatesummary ${showVariance ||
                                                                            selectedBudgetVariance === "netStly" ||
                                                                            selectedForecastVariance === "netStly"
                                                                            ? occ > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {occ}%
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-center ${showVariance ||
                                                                            selectedBudgetVariance === "netStly" ||
                                                                            selectedForecastVariance === "netStly"
                                                                            ? rms > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateRoom(rms)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "netStly" ||
                                                                            selectedForecastVariance === "netStly"
                                                                            ? adr > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateAmount(adr)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "netStly" ||
                                                                            selectedForecastVariance === "netStly"
                                                                            ? ""
                                                                            : "perbackground perbackground-rev"
                                                                            } ${showVariance ||
                                                                                selectedBudgetVariance === "netStly" ||
                                                                                selectedForecastVariance === "netStly"
                                                                                ? rev > 0
                                                                                    ? "greenText"
                                                                                    : "redText"
                                                                                : ""
                                                                            }`}
                                                                        value={rev}
                                                                    >
                                                                        {commonService.formateAmount(rev)}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    dailyLoading.stly && !expandedDailyData[item]?.stly ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (expandedDailyData[item]?.stly || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let dOcc = dayData.occ || 0;
                                                                            let dRms = dayData.rms || 0;
                                                                            let dAdr = dayData.adr || 0;
                                                                            let dRev = dayData.rev || 0;

                                                                            let isVariance = showVariance || selectedBudgetVariance === "netStly" || selectedForecastVariance === "netStly";
                                                                            let vOcc = dOcc;
                                                                            let vRms = dRms;
                                                                            let vAdr = dAdr;
                                                                            let vRev = dRev;

                                                                            if (isVariance) {
                                                                                let baseDay = {};
                                                                                if (showVariance) {
                                                                                    baseDay = (expandedDailyData[item]?.otb || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                                } else if (selectedBudgetVariance === "netStly") {
                                                                                    baseDay = (expandedDailyData[item]?.budget || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                                } else if (selectedForecastVariance === "netStly") {
                                                                                    baseDay = (expandedDailyData[item]?.forecast || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                                }
                                                                                vOcc = (baseDay.occ || 0) - (dayData.occ || 0);
                                                                                vRms = (baseDay.rms || 0) - (dayData.rms || 0);
                                                                                vAdr = (baseDay.adr || 0) - (dayData.adr || 0);
                                                                                vRev = (baseDay.rev || 0) - (dayData.rev || 0);
                                                                            }

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary ${isVariance ? (vOcc > 0 ? "greenText" : vOcc < 0 ? "redText" : "") : ""}`}>
                                                                                        {vOcc}% {/*Need To Bind OCC Value*/}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-center ${isVariance ? (vRms > 0 ? "greenText" : vRms < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateRoom(vRms)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vAdr > 0 ? "greenText" : vAdr < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vAdr)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vRev > 0 ? "greenText" : vRev < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vRev)}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}

                                                                {index === 11 && (
                                                                    <tr key={index}>
                                                                        <td className="boldTd">{parseInt(netStlyOcc / 12)}%</td>
                                                                        <td className="boldTd text-center"> {showVariance ||
                                                                            selectedBudgetVariance === "netStly" ||
                                                                            selectedForecastVariance === "netStly"
                                                                            ? commonService.formateRoom(
                                                                                varianceNetStlyRms
                                                                            )
                                                                            : commonService.formateRoom(netStlyRms)}</td>
                                                                        <td className="boldTd text-end">{showVariance
                                                                            ? commonService.formateAmount(
                                                                                getTotalAdr("netStly")
                                                                            )
                                                                            : netStlyRev !== 0 && netStlyRms !== 0
                                                                                ? commonService.formateAmount(
                                                                                    parseInt(netStlyRev / netStlyRms)
                                                                                )
                                                                                : commonService.formateAmount(0)}</td>
                                                                        <td className="boldTd text-end">{showVariance
                                                                            ? commonService.formateAmount(
                                                                                otbrev - netStlyRev
                                                                            )
                                                                            : commonService.formateAmount(
                                                                                netStlyRev
                                                                            )}</td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table id={tblids.totalLyWidget} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan={4}
                                                        className="text-center"
                                                    >
                                                        {showVariance
                                                            ? "OTB vs Total LY"
                                                            : selectedBudgetVariance === "totalLy"
                                                                ? "Budget vs Total LY"
                                                                : selectedForecastVariance === "totalLy"
                                                                    ? "Forecast vs Total LY"
                                                                    : "Total Ly"}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>OCC</th>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className="text-end">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {api === 0 ? (
                                                    totalLyData?.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={index}>
                                                                <td>{item?.occ}%</td>
                                                                <td className="text-center">{item?.rms}</td>
                                                                <td className="text-end">${item?.adr}</td>
                                                                <td
                                                                    className="text-end perbackground perbackground-rev"
                                                                    value={item?.rev}
                                                                >
                                                                    ${item?.rev}
                                                                </td>
                                                            </tr>
                                                            {index === totalLyData?.length - 1 && (
                                                                <tr>
                                                                    <td className="boldTd">0%</td>
                                                                    <td className="boldTd text-center">0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : totalLyLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={4} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    (totalLyData ||
                                                        varianceData ||
                                                        budgetVarianceData ||
                                                        forecastVarianceData) &&
                                                    month?.map((item, index) => {
                                                        let findMonthData = totalLyData?.filter((x) => x.month === item);
                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        let varianceMonthData = varianceData?.filter(
                                                            (x) => x?.month === item
                                                        );

                                                        let findBudgetVarianceData =
                                                            budgetVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let findForecastVarianceData =
                                                            forecastVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let occ = 0,
                                                            rms = 0,
                                                            adr = 0,
                                                            rev = 0,
                                                            adrVariance = 0,
                                                            revVariance = 0;
                                                        totalLyAdr =
                                                            totalLyAdr +
                                                            (findMonthData?.[0]?.adr
                                                                ? findMonthData?.[0]?.adr
                                                                : 0);
                                                        totalLyRev =
                                                            totalLyRev +
                                                            (findMonthData?.[0]?.rev
                                                                ? findMonthData?.[0]?.rev
                                                                : 0);
                                                        totalLyRms =
                                                            totalLyRms +
                                                            (findMonthData?.[0]?.rms
                                                                ? findMonthData?.[0]?.rms
                                                                : 0);
                                                        if (showVariance) {
                                                            occ = varianceMonthData?.[0]?.LY_OCC
                                                                ? varianceMonthData?.[0]?.LY_OCC
                                                                : 0;
                                                            rms = varianceMonthData?.[0]?.LY_RMS
                                                                ? varianceMonthData?.[0]?.LY_RMS
                                                                : 0;
                                                            adr = varianceMonthData?.[0]?.LY_ADR
                                                                ? varianceMonthData?.[0]?.LY_ADR
                                                                : 0;
                                                            rev = varianceMonthData?.[0]?.LY_REV
                                                                ? varianceMonthData?.[0]?.LY_REV
                                                                : 0;
                                                            adrVariance =
                                                                varianceMonthData?.[0]?.OTB_ADR > 0 &&
                                                                    findMonthData?.[0]?.adr > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_ADR
                                                                        ? varianceMonthData?.[0]?.OTB_ADR
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.adr
                                                                        ? findMonthData?.[0]?.adr
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(adrVariance) || isNaN(adrVariance)) {
                                                                adrVariance = 0;
                                                            }

                                                            revVariance =
                                                                varianceMonthData?.[0]?.OTB_REV > 0 &&
                                                                    findMonthData?.[0]?.rev > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_REV
                                                                        ? varianceMonthData?.[0]?.OTB_REV
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.rev
                                                                        ? findMonthData?.[0]?.rev
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(revVariance) || isNaN(revVariance)) {
                                                                revVariance = 0;
                                                            }

                                                            totalLyOcc =
                                                                totalLyOcc +
                                                                (varianceMonthData?.[0]?.LY_OCC
                                                                    ? varianceMonthData?.[0]?.LY_OCC
                                                                    : 0);
                                                            varianceTotalLyRms =
                                                                varianceTotalLyRms +
                                                                (varianceMonthData?.[0]?.LY_RMS
                                                                    ? varianceMonthData?.[0]?.LY_RMS
                                                                    : 0);
                                                        } else if (selectedBudgetVariance === "totalLy") {
                                                            occ = valueForBudgetVariance(
                                                                "LY_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "LY_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "LY_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "LY_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            totalLyOcc =
                                                                totalLyOcc +
                                                                valueForBudgetVariance(
                                                                    "LY_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceTotalLyRms =
                                                                varianceTotalLyRms +
                                                                valueForBudgetVariance(
                                                                    "LY_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedForecastVariance === "totalLy") {
                                                            let keyName = "Forecast";
                                                            if (selectedForecast === "rms") {
                                                                keyName = "RMS_Forecast";
                                                            } else if (selectedForecast === "user") {
                                                                keyName = "USER_Forecast";
                                                            }
                                                            else if (selectedForecast === "nova") {
                                                                keyName = "NOVA_Forecast";
                                                            }
                                                            occ = valueForBudgetVariance(
                                                                "LY_OCC",
                                                                findForecastVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "LY_RMS",
                                                                findForecastVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "LY_ADR",
                                                                findForecastVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "LY_REV",
                                                                findForecastVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_ADR`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_ADR`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_REV`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_REV`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            totalLyOcc =
                                                                totalLyOcc +
                                                                valueForBudgetVariance(
                                                                    "LY_OCC",
                                                                    findForecastVarianceData
                                                                );
                                                            budgetVarianceOtbRms =
                                                                budgetVarianceOtbRms +
                                                                valueForBudgetVariance(
                                                                    "LY_RMS",
                                                                    findForecastVarianceData
                                                                );
                                                        } else {
                                                            occ = findMonthData?.[0]?.occ ? findMonthData?.[0]?.occ : 0;
                                                            rms = findMonthData?.[0]?.rms ? findMonthData?.[0]?.rms : 0;
                                                            adr = findMonthData?.[0]?.adr ? findMonthData?.[0]?.adr : 0;
                                                            rev = findMonthData?.[0]?.rev ? findMonthData?.[0]?.rev : 0;

                                                            totalLyOcc = totalLyOcc + occ;
                                                        }

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td
                                                                        className={`generatesummary ${showVariance ||
                                                                            selectedBudgetVariance === "totalLy" ||
                                                                            selectedForecastVariance === "totalLy"
                                                                            ? occ > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {occ}%
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-center ${showVariance ||
                                                                            selectedBudgetVariance === "totalLy" ||
                                                                            selectedForecastVariance === "totalLy"
                                                                            ? rms > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateRoom(rms)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "totalLy" ||
                                                                            selectedForecastVariance === "totalLy"
                                                                            ? adr > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateAmount(adr)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "totalLy" ||
                                                                            selectedForecastVariance === "totalLy"
                                                                            ? ""
                                                                            : "perbackground perbackground-rev"
                                                                            } ${showVariance ||
                                                                                selectedBudgetVariance === "totalLy" ||
                                                                                selectedForecastVariance === "totalLy"
                                                                                ? rev > 0
                                                                                    ? "greenText"
                                                                                    : "redText"
                                                                                : ""
                                                                            }`}
                                                                        value={rev}
                                                                    >
                                                                        {commonService.formateAmount(rev)}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    dailyLoading.stly && !expandedDailyData[item]?.ly ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (expandedDailyData[item]?.ly || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let isVariance = showVariance || selectedBudgetVariance === "totalLy" || selectedForecastVariance === "totalLy";
                                                                            let baseDay = {};
                                                                            if (showVariance) {
                                                                                baseDay = (expandedDailyData[item]?.otb || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            } else if (selectedBudgetVariance === "totalLy") {
                                                                                baseDay = (expandedDailyData[item]?.budget || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            } else if (selectedForecastVariance === "totalLy") {
                                                                                baseDay = (expandedDailyData[item]?.forecast || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            }

                                                                            let vOcc = isVariance ? ((baseDay.occ || 0) - (dayData.occ || 0)) : (dayData.occ || 0);
                                                                            let vRms = isVariance ? ((baseDay.rms || 0) - (dayData.rms || 0)) : (dayData.rms || 0);
                                                                            let vAdr = isVariance ? ((baseDay.adr || 0) - (dayData.adr || 0)) : (dayData.adr || 0);
                                                                            let vRev = isVariance ? ((baseDay.rev || 0) - (dayData.rev || 0)) : (dayData.rev || 0);

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary ${isVariance ? (vOcc > 0 ? "greenText" : vOcc < 0 ? "redText" : "") : ""}`}>
                                                                                        {vOcc}% {/*Need To Bind OCC Value*/}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-center ${isVariance ? (vRms > 0 ? "greenText" : vRms < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateRoom(vRms)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vAdr > 0 ? "greenText" : vAdr < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vAdr)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vRev > 0 ? "greenText" : vRev < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vRev)}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}

                                                                {index === 11 && (
                                                                    <tr key={index}>
                                                                        <td className="boldTd">{parseInt(totalLyOcc / 12)}%</td>
                                                                        <td className="text-center boldTd">{showVariance ||
                                                                            selectedBudgetVariance === "totalLy"
                                                                            ? commonService.formateRoom(
                                                                                varianceTotalLyRms
                                                                            )
                                                                            : commonService.formateRoom(totalLyRms)}</td>
                                                                        <td className="text-end boldTd">{showVariance
                                                                            ? commonService.formateAmount(
                                                                                getTotalAdr("totalLy")
                                                                            )
                                                                            : totalLyRev !== 0 && totalLyRms !== 0
                                                                                ? commonService.formateAmount(
                                                                                    parseInt(totalLyRev / totalLyRms)
                                                                                )
                                                                                : commonService.formateAmount(0)}</td>
                                                                        <td className="text-end boldTd">{showVariance
                                                                            ? commonService.formateAmount(
                                                                                otbrev - totalLyRev
                                                                            )
                                                                            : commonService.formateAmount(
                                                                                totalLyRev
                                                                            )}</td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table id={tblids.budgetWidget} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan={2}
                                                        className="text-center"
                                                    >
                                                        {showVariance
                                                            ? "OTB vs Budget"
                                                            : selectedForecastVariance === "budget"
                                                                ? "Forecast vs Budget"
                                                                : "Budget"}
                                                    </th>
                                                    <th
                                                        className="text-center varianceField"
                                                        colSpan={2}
                                                    >
                                                        <Form.Select id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "rms", propertyCode)}
                                                            value={selectedBudgetVariance}
                                                            onChange={(e) => {
                                                                if (e.target.value !== "") {
                                                                    setShowVariance(false);
                                                                    setSelectedForecastVariance("");
                                                                }
                                                                if (
                                                                    e.target.value === "ema" ||
                                                                    e.target.value === "rms" ||
                                                                    e.target.value === "user" ||
                                                                    e.target.value === "nova"
                                                                ) {
                                                                    setSelectedForecast(e.target.value);
                                                                }
                                                                setSelectedBudgetVariance(e.target.value);
                                                            }}
                                                        >
                                                            <option value="">Select Variance</option>
                                                            <option value={"otb"}>On the Books</option>
                                                            <option value={"netStly"}>Net STLY</option>
                                                            <option value={"totalLy"}>Total LY</option>
                                                            <option value={"ema"}>System Forecast</option>
                                                            <option value={"rms"}>RMS Forecast</option>
                                                            <option value={"user"}>User Forecast</option>
                                                            <option value={"nova"}>RM Copilot Forecast</option>
                                                        </Form.Select>
                                                        <span style={{ display: "none" }}>
                                                            {commonService.ForecastTypeDisplayLable(selectedBudgetVariance)}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>OCC</th>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className="text-end">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {api === 0 ? (
                                                    budgetData?.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={index}>
                                                                <td>{item?.occ}%</td>
                                                                <td className="text-center">{item?.rms}</td>
                                                                <td className="text-end">${item?.adr}</td>
                                                                <td
                                                                    className="text-end perbackground perbackground-rev"
                                                                    value={item?.rev}
                                                                >
                                                                    ${item?.rev}
                                                                </td>
                                                            </tr>
                                                            {index === budgetData?.length - 1 && (
                                                                <tr>
                                                                    <td className="boldTd">0%</td>
                                                                    <td className="boldTd text-center">0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : budgetLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={4} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    (budgetData ||
                                                        varianceData ||
                                                        forecastVarianceData) &&
                                                    month?.map((item, index) => {
                                                        let findMonthData = budgetData?.filter((x) => x.month === item);
                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        let varianceMonthData = varianceData?.filter(
                                                            (x) => x?.month === item
                                                        );

                                                        let findForecastVarianceData =
                                                            forecastVarianceData?.filter(
                                                                (x) => x?.month === item
                                                            );

                                                        let occ = 0,
                                                            rms = 0,
                                                            adr = 0,
                                                            rev = 0,
                                                            adrVariance = 0,
                                                            revVariance = 0;
                                                        budgetAdr =
                                                            budgetAdr +
                                                            (findMonthData?.[0]?.adr
                                                                ? findMonthData?.[0]?.adr
                                                                : 0);
                                                        budgetRev =
                                                            budgetRev +
                                                            (findMonthData?.[0]?.rev
                                                                ? findMonthData?.[0]?.rev
                                                                : 0);
                                                        budgetRms =
                                                            budgetRms +
                                                            (findMonthData?.[0]?.rms
                                                                ? findMonthData?.[0]?.rms
                                                                : 0);
                                                        if (showVariance) {
                                                            occ = varianceMonthData?.[0]?.Budget_OCC
                                                                ? varianceMonthData?.[0]?.Budget_OCC
                                                                : 0;
                                                            rms = varianceMonthData?.[0]?.Budget_RMS
                                                                ? varianceMonthData?.[0]?.Budget_RMS
                                                                : 0;
                                                            adr = varianceMonthData?.[0]?.Budget_ADR
                                                                ? varianceMonthData?.[0]?.Budget_ADR
                                                                : 0;
                                                            rev = varianceMonthData?.[0]?.Budget_REV
                                                                ? varianceMonthData?.[0]?.Budget_REV
                                                                : 0;
                                                            adrVariance =
                                                                varianceMonthData?.[0]?.OTB_ADR > 0 &&
                                                                    findMonthData?.[0]?.adr > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_ADR
                                                                        ? varianceMonthData?.[0]?.OTB_ADR
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.adr
                                                                        ? findMonthData?.[0]?.adr
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(adrVariance) || isNaN(adrVariance)) {
                                                                adrVariance = 0;
                                                            }

                                                            revVariance =
                                                                varianceMonthData?.[0]?.OTB_REV > 0 &&
                                                                    findMonthData?.[0]?.rev > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_REV
                                                                        ? varianceMonthData?.[0]?.OTB_REV
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.rev
                                                                        ? findMonthData?.[0]?.rev
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(revVariance) || isNaN(revVariance)) {
                                                                revVariance = 0;
                                                            }

                                                            budgetOcc =
                                                                budgetOcc +
                                                                (varianceMonthData?.[0]?.Budget_OCC
                                                                    ? varianceMonthData?.[0]?.Budget_OCC
                                                                    : 0);
                                                            varianceBudgetRms =
                                                                varianceBudgetRms +
                                                                (varianceMonthData?.[0]?.Budget_RMS
                                                                    ? varianceMonthData?.[0]?.Budget_RMS
                                                                    : 0);
                                                        } else if (selectedForecastVariance === "budget") {
                                                            let keyName = "Forecast";
                                                            if (selectedForecast === "rms") {
                                                                keyName = "RMS_Forecast";
                                                            } else if (selectedForecast === "user") {
                                                                keyName = "USER_Forecast";
                                                            }
                                                            else if (selectedForecast === "nova") {
                                                                keyName = "NOVA_Forecast";
                                                            }
                                                            occ = valueForBudgetVariance(
                                                                "Budget_OCC",
                                                                findForecastVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "Budget_RMS",
                                                                findForecastVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "Budget_ADR",
                                                                findForecastVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "Budget_REV",
                                                                findForecastVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_ADR`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_ADR`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    `${keyName}_REV`,
                                                                    findForecastVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        `${keyName}_REV`,
                                                                        findForecastVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            budgetOcc =
                                                                budgetOcc +
                                                                valueForBudgetVariance(
                                                                    "Budget_OCC",
                                                                    findForecastVarianceData
                                                                );
                                                            budgetVarianceOtbRms =
                                                                budgetVarianceOtbRms +
                                                                valueForBudgetVariance(
                                                                    "Budget_RMS",
                                                                    findForecastVarianceData
                                                                );
                                                        } else {
                                                            occ = findMonthData?.[0]?.occ ? findMonthData?.[0]?.occ : 0;
                                                            rms = findMonthData?.[0]?.rms ? findMonthData?.[0]?.rms : 0;
                                                            adr = findMonthData?.[0]?.adr ? findMonthData?.[0]?.adr : 0;
                                                            rev = findMonthData?.[0]?.rev ? findMonthData?.[0]?.rev : 0;

                                                            budgetOcc = budgetOcc + occ;
                                                        }

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td
                                                                        className={`generatesummary ${showVariance ||
                                                                            selectedForecastVariance === "budget"
                                                                            ? occ > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {occ}%
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-center ${showVariance ||
                                                                            selectedForecastVariance === "budget"
                                                                            ? rms > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateRoom(rms)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedForecastVariance === "budget"
                                                                            ? adr > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateAmount(adr)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedForecastVariance === "budget"
                                                                            ? ""
                                                                            : "perbackground perbackground-rev"
                                                                            } ${showVariance ||
                                                                                selectedForecastVariance === "budget"
                                                                                ? rev > 0
                                                                                    ? "greenText"
                                                                                    : "redText"
                                                                                : ""
                                                                            }`}
                                                                        value={rev}
                                                                    >
                                                                        {commonService.formateAmount(rev)}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    dailyLoading.budget && !expandedDailyData[item]?.budget ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (expandedDailyData[item]?.budget || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let isVariance = showVariance || selectedForecastVariance === "budget";
                                                                            let baseDay = {};
                                                                            if (showVariance) {
                                                                                baseDay = (expandedDailyData[item]?.otb || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            } else if (selectedForecastVariance === "budget") {
                                                                                baseDay = (expandedDailyData[item]?.forecast || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            }

                                                                            let vOcc = isVariance ? ((baseDay.occ || 0) - (dayData.occ || 0)) : (dayData.occ || 0);
                                                                            let vRms = isVariance ? ((baseDay.rms || 0) - (dayData.rms || 0)) : (dayData.rms || 0);
                                                                            let vAdr = isVariance ? ((baseDay.adr || 0) - (dayData.adr || 0)) : (dayData.adr || 0);
                                                                            let vRev = isVariance ? ((baseDay.rev || 0) - (dayData.rev || 0)) : (dayData.rev || 0);

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary ${isVariance ? (vOcc > 0 ? "greenText" : vOcc < 0 ? "redText" : "") : ""}`}>
                                                                                        {vOcc}% {/*Need To Bind OCC Value*/}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-center ${isVariance ? (vRms > 0 ? "greenText" : vRms < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateRoom(vRms)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vAdr > 0 ? "greenText" : vAdr < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vAdr)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vRev > 0 ? "greenText" : vRev < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vRev)}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}

                                                                {index === 11 && (
                                                                    <tr key={index}>

                                                                        <td className="boldTd">
                                                                            {budgetOcc > 0
                                                                                ? parseInt(budgetOcc / 12)
                                                                                : 0}
                                                                            %
                                                                        </td>
                                                                        <td className="text-center boldTd">
                                                                            {showVariance
                                                                                ? commonService.formateRoom(
                                                                                    varianceBudgetRms
                                                                                )
                                                                                : commonService.formateRoom(budgetRms)}
                                                                        </td>
                                                                        <td className="text-end boldTd">

                                                                            {showVariance
                                                                                ? commonService.formateAmount(
                                                                                    getTotalAdr("Budget")
                                                                                )
                                                                                : budgetRev !== 0 && budgetRms !== 0
                                                                                    ? commonService.formateAmount(
                                                                                        parseInt(budgetRev / budgetRms)
                                                                                    )
                                                                                    : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end boldTd">
                                                                            {showVariance
                                                                                ? commonService.formateAmount(
                                                                                    otbrev - budgetRev
                                                                                )
                                                                                : commonService.formateAmount(
                                                                                    budgetRev
                                                                                )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="ps-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable nowrap">
                                    <div className="stripped__table">
                                        <Table id={tblids.emaForecast} responsive asofdate={commonService.getDateInFormat(para?.asOfDate)}>
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan={2}
                                                        className="text-center"
                                                    >
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {showVariance ? (
                                                                <span className="me-2 fw-bold text-nowrap">OTB vs</span>
                                                            ) : (selectedBudgetVariance === "ema" ||
                                                                selectedBudgetVariance === "rms" ||
                                                                selectedBudgetVariance === "user" ||
                                                                selectedBudgetVariance === "nova") ? (
                                                                <span className="me-2 fw-bold text-nowrap">Budget vs</span>
                                                            ) : null}
                                                            <Form.Select id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "occ", propertyCode)}
                                                                value={selectedForecast}
                                                                onChange={(e) => {
                                                                    setSelectedBudgetVariance("");
                                                                    setSelectedForecast(e.target.value);
                                                                    setExpandedMonth(null);
                                                                    setExpandedDailyData({});
                                                                }}
                                                            >
                                                                <option value={"ema"}>System Forecast</option>
                                                                <option value={"rms"}>RMS Forecast</option>
                                                                <option value={"user"}>User Forecast</option>
                                                                <option value={"nova"}>RM Copilot Forecast</option>
                                                            </Form.Select>
                                                        </div>
                                                        <span style={{ display: "none" }}>
                                                            {commonService.ForecastTypeDisplayLable(selectedForecast)}
                                                        </span>
                                                    </th>
                                                    <th
                                                        className="text-center varianceField"
                                                        colSpan={2}
                                                    >
                                                        <Form.Select id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "rms", propertyCode)}
                                                            value={selectedForecastVariance}
                                                            onChange={(e) => {
                                                                if (e.target.value !== "") {
                                                                    setShowVariance(false);
                                                                    setSelectedBudgetVariance("");
                                                                }
                                                                setSelectedForecastVariance(e.target.value);
                                                            }}
                                                        >
                                                            <option value="">Select Variance</option>
                                                            <option value={"otb"}>On the Books</option>
                                                            <option value={"netStly"}>Net STLY</option>
                                                            <option value={"totalLy"}>Total LY</option>
                                                            <option value={"budget"}>Budget</option>
                                                        </Form.Select>
                                                        <span style={{ display: "none" }}>
                                                            {commonService.ForecastTypeDisplayLable(selectedForecastVariance)}
                                                        </span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>OCC</th>
                                                    <th className="text-center">RMS</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className="text-end">REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {api === 0 ? (
                                                    emaForecastData?.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr key={index}>
                                                                <td>{item?.occ}%</td>
                                                                <td className="text-center">{item?.rms}</td>
                                                                <td className="text-end">${item?.adr}</td>
                                                                <td
                                                                    className="text-end perbackground perbackground-rev"
                                                                    value={item?.rev}
                                                                >
                                                                    ${item?.rev}
                                                                </td>
                                                                {/* <td>{item?.var}%</td> */}
                                                            </tr>
                                                            {index === 11 && (
                                                                <tr>
                                                                    <td className="boldTd">0%</td>
                                                                    <td className="boldTd text-center">0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    <td className="boldTd text-end">$0</td>
                                                                    {/* <td className="boldTd">0%</td> */}
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                ) : emaForecastLoading ? (
                                                    <tr className="table-loader-row">
                                                        <td colSpan={4} className="text-center relative-loader" style={{ height: "300px", position: "relative" }}>
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    (emaForecastData ||
                                                        varianceData ||
                                                        budgetVarianceData) &&
                                                    month?.map((item, index) => {
                                                        let findMonthData = emaForecastData?.filter((x) => x.month === item);
                                                        const daysInMonth = getDaysInMonth(item, selectedYear);

                                                        let varianceMonthData = varianceData?.filter(
                                                            (x) => x?.month === item
                                                        );

                                                        let findBudgetVarianceData =
                                                            budgetVarianceData?.filter(
                                                                (x) => x.month === item
                                                            );

                                                        let occ = 0,
                                                            rms = 0,
                                                            adr = 0,
                                                            rev = 0,
                                                            adrVariance = 0,
                                                            revVariance = 0;
                                                        emaForecastAdr =
                                                            emaForecastAdr +
                                                            (findMonthData?.[0]?.adr
                                                                ? findMonthData?.[0]?.adr
                                                                : 0);
                                                        emaForecastRev =
                                                            emaForecastRev +
                                                            (findMonthData?.[0]?.rev
                                                                ? findMonthData?.[0]?.rev
                                                                : 0);
                                                        emaForecastRms =
                                                            emaForecastRms +
                                                            (findMonthData?.[0]?.rms
                                                                ? findMonthData?.[0]?.rms
                                                                : 0);
                                                        if (showVariance) {
                                                            let keyName = "Forecast";
                                                            if (selectedForecast === "rms") {
                                                                keyName = "RMS_Forecast";
                                                            } else if (selectedForecast === "user") {
                                                                keyName = "USER_Forecast";
                                                            }
                                                            else if (selectedForecast === "nova") {
                                                                keyName = "NOVA_Forecast";
                                                            }
                                                            occ = varianceMonthData?.[0]?.[`${keyName}_OCC`]
                                                                ? varianceMonthData?.[0]?.[`${keyName}_OCC`]
                                                                : 0;
                                                            rms = varianceMonthData?.[0]?.[`${keyName}_RMS`]
                                                                ? varianceMonthData?.[0]?.[`${keyName}_RMS`]
                                                                : 0;
                                                            adr = varianceMonthData?.[0]?.[`${keyName}_ADR`]
                                                                ? varianceMonthData?.[0]?.[`${keyName}_ADR`]
                                                                : 0;
                                                            rev = varianceMonthData?.[0]?.[`${keyName}_REV`]
                                                                ? varianceMonthData?.[0]?.[`${keyName}_REV`]
                                                                : 0;
                                                            adrVariance =
                                                                varianceMonthData?.[0]?.OTB_ADR > 0 &&
                                                                    findMonthData?.[0]?.adr > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_ADR
                                                                        ? varianceMonthData?.[0]?.OTB_ADR
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.adr
                                                                        ? findMonthData?.[0]?.adr
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(adrVariance) || isNaN(adrVariance)) {
                                                                adrVariance = 0;
                                                            }

                                                            revVariance =
                                                                varianceMonthData?.[0]?.OTB_REV > 0 &&
                                                                    findMonthData?.[0]?.rev > 0
                                                                    ? ((varianceMonthData?.[0]?.OTB_REV
                                                                        ? varianceMonthData?.[0]?.OTB_REV
                                                                        : 0) *
                                                                        100) /
                                                                    (findMonthData?.[0]?.rev
                                                                        ? findMonthData?.[0]?.rev
                                                                        : 0) -
                                                                    100
                                                                    : 0;
                                                            if (!isFinite(revVariance) || isNaN(revVariance)) {
                                                                revVariance = 0;
                                                            }

                                                            emaForecastOcc =
                                                                emaForecastOcc +
                                                                (varianceMonthData?.[0]?.[`${keyName}_OCC`]
                                                                    ? varianceMonthData?.[0]?.[`${keyName}_OCC`]
                                                                    : 0);
                                                            varianceForecastRms =
                                                                varianceForecastRms +
                                                                (varianceMonthData?.[0]?.[`${keyName}_RMS`]
                                                                    ? varianceMonthData?.[0]?.[`${keyName}_RMS`]
                                                                    : 0);
                                                        } else if (selectedBudgetVariance === "ema") {
                                                            occ = valueForBudgetVariance(
                                                                "Forecast_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "Forecast_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "Forecast_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "Forecast_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            emaForecastOcc =
                                                                emaForecastOcc +
                                                                valueForBudgetVariance(
                                                                    "Forecast_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceForecastRms =
                                                                varianceForecastRms +
                                                                valueForBudgetVariance(
                                                                    "Forecast_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedBudgetVariance === "rms") {
                                                            occ = valueForBudgetVariance(
                                                                "RMS_Forecast_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "RMS_Forecast_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "RMS_Forecast_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "RMS_Forecast_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            emaForecastOcc =
                                                                emaForecastOcc +
                                                                valueForBudgetVariance(
                                                                    "RMS_Forecast_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceForecastRms =
                                                                varianceForecastRms +
                                                                valueForBudgetVariance(
                                                                    "RMS_Forecast_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedBudgetVariance === "user") {
                                                            occ = valueForBudgetVariance(
                                                                "USER_Forecast_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "USER_Forecast_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "USER_Forecast_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "USER_Forecast_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            emaForecastOcc =
                                                                emaForecastOcc +
                                                                valueForBudgetVariance(
                                                                    "USER_Forecast_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceForecastRms =
                                                                varianceForecastRms +
                                                                valueForBudgetVariance(
                                                                    "USER_Forecast_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else if (selectedBudgetVariance === "nova") {
                                                            occ = valueForBudgetVariance(
                                                                "NOVA_Forecast_OCC",
                                                                findBudgetVarianceData
                                                            );
                                                            rms = valueForBudgetVariance(
                                                                "NOVA_Forecast_RMS",
                                                                findBudgetVarianceData
                                                            );
                                                            adr = valueForBudgetVariance(
                                                                "NOVA_Forecast_ADR",
                                                                findBudgetVarianceData
                                                            );
                                                            rev = valueForBudgetVariance(
                                                                "NOVA_Forecast_REV",
                                                                findBudgetVarianceData
                                                            );

                                                            adrVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_ADR",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("adr", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_ADR",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "adr",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            revVariance =
                                                                valueForBudgetVariance(
                                                                    "Budget_REV",
                                                                    findBudgetVarianceData
                                                                ) > 0 &&
                                                                    valueForBudgetVariance("rev", findMonthData) > 0
                                                                    ? (valueForBudgetVariance(
                                                                        "Budget_REV",
                                                                        findBudgetVarianceData
                                                                    ) *
                                                                        100) /
                                                                    valueForBudgetVariance(
                                                                        "rev",
                                                                        findMonthData
                                                                    ) -
                                                                    100
                                                                    : 0;

                                                            emaForecastOcc =
                                                                emaForecastOcc +
                                                                valueForBudgetVariance(
                                                                    "NOVA_Forecast_OCC",
                                                                    findBudgetVarianceData
                                                                );
                                                            varianceForecastRms =
                                                                varianceForecastRms +
                                                                valueForBudgetVariance(
                                                                    "NOVA_Forecast_RMS",
                                                                    findBudgetVarianceData
                                                                );
                                                        } else {
                                                            occ = findMonthData?.[0]?.occ ? findMonthData?.[0]?.occ : 0;
                                                            rms = findMonthData?.[0]?.rms ? findMonthData?.[0]?.rms : 0;
                                                            adr = findMonthData?.[0]?.adr ? findMonthData?.[0]?.adr : 0;
                                                            rev = findMonthData?.[0]?.rev ? findMonthData?.[0]?.rev : 0;

                                                            emaForecastOcc = emaForecastOcc + occ;
                                                        }

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr key={index}>
                                                                    <td
                                                                        className={`generatesummary ${showVariance ||
                                                                            selectedBudgetVariance === "ema" ||
                                                                            selectedBudgetVariance === "rms" ||
                                                                            selectedBudgetVariance === "user" ||
                                                                            selectedBudgetVariance === "nova"
                                                                            ? occ > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {occ}%
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-center ${showVariance ||
                                                                            selectedBudgetVariance === "ema" ||
                                                                            selectedBudgetVariance === "rms" ||
                                                                            selectedBudgetVariance === "user" ||
                                                                            selectedBudgetVariance === "nova"
                                                                            ? rms > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateRoom(rms)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "ema" ||
                                                                            selectedBudgetVariance === "rms" ||
                                                                            selectedBudgetVariance === "user" ||
                                                                            selectedBudgetVariance === "nova"

                                                                            ? adr > 0
                                                                                ? "greenText"
                                                                                : "redText"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {commonService.formateAmount(adr)}
                                                                    </td>
                                                                    <td
                                                                        className={`generatesummary text-end ${showVariance ||
                                                                            selectedBudgetVariance === "ema" ||
                                                                            selectedBudgetVariance === "rms" ||
                                                                            selectedBudgetVariance === "user" ||
                                                                            selectedBudgetVariance === "nova"
                                                                            ? ""
                                                                            : "perbackground perbackground-rev"
                                                                            } ${showVariance ||
                                                                                selectedBudgetVariance === "ema" ||
                                                                                selectedBudgetVariance === "rms" ||
                                                                                selectedBudgetVariance === "user" ||
                                                                                selectedBudgetVariance === "nova"
                                                                                ? rev > 0
                                                                                    ? "greenText"
                                                                                    : "redText"
                                                                                : ""
                                                                            }`}
                                                                        value={rev}
                                                                    >
                                                                        {commonService.formateAmount(rev)}
                                                                    </td>
                                                                </tr>
                                                                {expandedMonth === item && (
                                                                    dailyLoading.forecast && !expandedDailyData[item]?.forecast ? (
                                                                        <tr className="expanded-row expanded-loader-row" style={{ height: `${(daysInMonth?.length || 30) * 26}px` }}>
                                                                            <td
                                                                                colSpan={4}
                                                                                className="text-center relative-loader"
                                                                                style={{ height: `${(daysInMonth?.length || 30) * 26}px`, minHeight: `${(daysInMonth?.length || 30) * 26}px`, verticalAlign: "middle" }}
                                                                            >
                                                                                <Loader />
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        daysInMonth?.map((dateStr, dIdx) => {
                                                                            let dayData = (expandedDailyData[item]?.forecast || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            let isVariance = showVariance || selectedBudgetVariance === "ema" || selectedBudgetVariance === "rms" || selectedBudgetVariance === "user" || selectedBudgetVariance === "nova";
                                                                            let baseDay = {};
                                                                            if (showVariance) {
                                                                                baseDay = (expandedDailyData[item]?.otb || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            } else if (
                                                                                selectedBudgetVariance === "ema" ||
                                                                                selectedBudgetVariance === "rms" ||
                                                                                selectedBudgetVariance === "user" ||
                                                                                selectedBudgetVariance === "nova"
                                                                            ) {
                                                                                baseDay = (expandedDailyData[item]?.budget || [])?.find(x => moment(x.date || x.Date).format("YYYY-MM-DD") === dateStr) || {};
                                                                            }
                                                                            let vOcc = isVariance ? ((baseDay.occ || 0) - (dayData.occ || 0)) : (dayData.occ || 0);
                                                                            let vRms = isVariance ? ((baseDay.rms || 0) - (dayData.rms || 0)) : (dayData.rms || 0);
                                                                            let vAdr = isVariance ? ((baseDay.adr || 0) - (dayData.adr || 0)) : (dayData.adr || 0);
                                                                            let vRev = isVariance ? ((baseDay.rev || 0) - (dayData.rev || 0)) : (dayData.rev || 0);

                                                                            return (
                                                                                <tr key={dIdx} className="expanded-row">
                                                                                    <td className={`generatesummary ${isVariance ? (vOcc > 0 ? "greenText" : vOcc < 0 ? "redText" : "") : ""}`}>
                                                                                        {vOcc}%  {/*Need To Bind OCC Value*/}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-center ${isVariance ? (vRms > 0 ? "greenText" : vRms < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateRoom(vRms)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vAdr > 0 ? "greenText" : vAdr < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vAdr)}
                                                                                    </td>
                                                                                    <td className={`generatesummary text-end ${isVariance ? (vRev > 0 ? "greenText" : vRev < 0 ? "redText" : "") : ""}`}>
                                                                                        {commonService.formateAmount(vRev)}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    )
                                                                )}

                                                                {index === 11 && (
                                                                    <tr>

                                                                        <td className="boldTd">
                                                                            {emaForecastOcc > 0
                                                                                ? parseInt(emaForecastOcc / 12)
                                                                                : 0}
                                                                            %
                                                                        </td>
                                                                        <td className="boldTd text-center">
                                                                            {showVariance ||
                                                                                selectedBudgetVariance === "ema" ||
                                                                                selectedBudgetVariance === "rms" ||
                                                                                selectedBudgetVariance === "user" ||
                                                                                selectedBudgetVariance === "nova"
                                                                                ? commonService.formateRoom(
                                                                                    varianceForecastRms
                                                                                )
                                                                                : commonService.formateRoom(
                                                                                    emaForecastRms
                                                                                )}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {showVariance
                                                                                ? commonService.formateAmount(
                                                                                    getTotalAdr("forecast")
                                                                                )
                                                                                : emaForecastRev !== 0 &&
                                                                                    emaForecastRms !== 0
                                                                                    ? commonService.formateAmount(
                                                                                        parseInt(
                                                                                            emaForecastRev / emaForecastRms
                                                                                        )
                                                                                    )
                                                                                    : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {showVariance
                                                                                ? commonService.formateAmount(
                                                                                    otbrev - emaForecastRev
                                                                                )
                                                                                : commonService.formateAmount(
                                                                                    emaForecastRev
                                                                                )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {getTotalForVariance()}
            {api !== 0 && (
                <div style={{ position: "relative" }}>
                    <Comments
                        widgetDetails={para}
                        editorId={"AnnualSummaryDrilldown"}
                        aiGeneratedComment={aiComment}
                    />
                    <img id={commonService.generateGlobalClickTrackerID("AnnualSummaryDrilldown", "chaticon", propertyCode)}
                        src={chatIcon}
                        alt="chatIcon"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleAnnualSummaryChat();
                        }}
                        style={{
                            display: "none",
                            position: "absolute",
                            right: "35px",
                            height: "20px",
                            top: "8px",
                            zIndex: "999999",
                            cursor: "pointer",
                        }}
                    />
                </div>
            )}

            {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
            {showChatModal && (
                <AnnualSummaryChatModal
                    showModal={showChatModal}
                    closeModal={closeChatModal}
                    payload={chatApiPayloadRef.current}
                />
            )}
            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 11 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            // pickupDate={
                            //   selectPickupDate
                            //     ? selectPickupDate
                            //     : singleDatePickupDateRef.current
                            // }
                            pickupDate={
                                selectSevenPickupDate
                                    ? selectSevenPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />
                    </div>
                </Popover>
            </Overlay>

            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                    para={para}
                />
            )}
            {showDailyNoteSidebar && (
                <WidgetNote
                    show={showDailyNoteSidebar}
                    handleClose={closeDailyNoteSideBar}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                    dateForNote={clickedDateForNote.current}
                />
            )}
        </div>
    );
};

export default AnnualSummaryDrilldown;
